import React, { useState, useEffect, useRef } from "react";
import style from "./Assessment.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurl } from "../Url";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import TrophyImage from "../../assests/Trophy.png";
import SecondTrophyImage from "../../assests/SecondTrophy.png";
import ThirdTrophyImage from "../../assests/ThirdTrophy.png";
import FourthTrophyImage from "../../assests/FourthTrophy.png";
import HintImage from "../../assests/hint1.svg";
import HintImage2 from "../../assests/hint2.svg";
import { Doughnut } from "react-chartjs-2";
import Loader from "../Loder/Loader";
import lessonImage from "../../assests/online lesson.png";
import timeImage from "../../assests/Time.png";
import questionImage from "../../assests/19 Questionnaire.png";
import motivationImage from "../../assests/Motivation.png";
import { Alert, Snackbar } from "@mui/material";
import { FaCheck } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
// import FailedImage from "../../assests/TrainImage.png";
import { AiOutlineClose, AiOutlineDelete } from "react-icons/ai";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Coins from "../../assests/Animations/CoinsGif.gif";
import Lottie from "lottie-react";
import coinsLottie from "../../Animation/Animation -Coins.json";
import { fetchUserDetails } from "../../Slices/UserSlice";
import { useDispatch } from "react-redux";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// import CircularProgress from "@mui/material/CircularProgress";

const CORRECT_MESSAGES = [
  "You are correct!",
  "Correct!",
  "You got it right!",
  "You’re right!",
  "Right answer!",
  "That’s right!",
  "You answered correctly!",
  "That’s the right answer!",
  "Spot on!",
  "Correct answer!",
  "Perfect!",
];

const INCORRECT_MESSAGES = [
  "That’s not right – see the explanation below then try the next question.",
  "Keep practising - you’ll get there!",
  "Keep going – practice makes perfect!",
  "Don’t worry - you need a bit more practice, that’s all!",
];

const parseSentence = (sentence = "") => {
  if (!sentence) return [];
  let cleaned = sentence.trim();
  if (cleaned.toLowerCase().startsWith("<p>") && cleaned.toLowerCase().endsWith("</p>")) {
    cleaned = cleaned.slice(3, -4).trim();
  }
  cleaned = cleaned.replace(/^(?:<br\s*\/?>)+|(?:<br\s*\/?>)+$/gi, "").trim();

  const regex = /(<u>.*?<\/u>|<[a-zA-Z0-9]+[^>]*style=["'][^"']*color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)[^"']*["'][^>]*>.*?<\/[a-zA-Z0-9]+>)/gi;
  const parts = cleaned.split(regex);
  return parts.map((part) => {
    const trimmed = part.trim();
    let isDraggable = false;
    
    if (trimmed.startsWith("<") && trimmed.endsWith(">")) {
      if (/^<u>/i.test(trimmed) && /<\/u>$/i.test(trimmed)) {
        isDraggable = true;
      } else {
        const hasStyle = /style=["']/i.test(trimmed);
        const hasOrangeColor = /color:\s*(?:rgb\(\s*255\s*,\s*122\s*,\s*0\s*\)|#ff7a00|#FF7A00)/i.test(trimmed);
        if (hasStyle && hasOrangeColor) {
          isDraggable = true;
        }
      }
    }
    
    if (isDraggable) {
      const word = part.replace(/<[^>]+>/g, "").trim();
      return { isDraggable: true, word };
    }
    
    return { isDraggable: false, text: part };
  });
};

const Assessment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const state = location.state;
  const Topic = state?.singleTopic;
  const learning_id = state?.learning;
  const main_topic_id = state?.mainID;
  const topicNo = state?.topicNo;
  const aiID = state?.aiID;
  const admin_Mapped_Lessons = state?.mapped;

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");

  const [assessment, setAssessment] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentAssessment, setCurrentAssessment] = useState({});
  const [validateClicked, setValidateClicked] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [assessmentData, setAssessmentData] = useState({});
  const [finishPopup, setFinishPopup] = useState(false);
  const [result, setResult] = useState(false);
  const [summaryDetail, setSummaryDetail] = useState({});
  const inputRefs = useRef({});
  const [loading, setLoading] = useState(true);
  const [trialUser, setTrailUser] = useState(false);
  const [error, setError] = useState("");
  const [failedPopup, setFailedPopup] = useState(false);
  const highlightRefs = useRef({});
  const quillRef = useRef();
  const [achievementPopup, setAchievementPopup] = useState(false);
  const [collectPopup, setCollectPopup] = useState(false);
  const [carouselData, setCarouselData] = useState([]);
  const [points, setPoints] = useState("");
  const [showHint, setShowHint] = useState(false);
  const [popupMsg, setPopupMsg] = useState(false);
  const [showPopupMsg, setShowPopupMsg] = useState(false);
  const [coinsLossAnimation, setCoinsLossAnimation] = useState(false);
  const [hintDialog, setHintDialog] = useState(false);
  const hintRef = useRef();
  const [wrongAnswerCount, setWrongAnswerCount] = useState(0);
  const [coinsAnimation,setCoinsAnimation]=useState(false)
  const [submitError, setSubmitError] = useState(false);
  const [activeDropTarget, setActiveDropTarget] = useState(null);

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [backButtonWarning, setBackButtonWarning] = useState(false);
  const [unansweredSelectDropdowns, setUnansweredSelectDropdowns] = useState([]);
  const beforeUnloadHandlerRef = useRef(null);
  const popStateHandlerRef = useRef(null);
  const resultRef = useRef(false);
  const navigationDataRef = useRef({});
  const correctMsgIndexRef = useRef(0);
  const incorrectMsgIndexRef = useRef(0);
  const [showXpInfo, setShowXpInfo] = useState(false);

  const nextSlide = () => {
    setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlideIndex(
      (prevIndex) => (prevIndex - 1 + carouselData.length) % carouselData.length
    );
  };
  useEffect(() => {
    const close = () => setShowXpInfo(false);

    window.addEventListener("click", close);

    return () => {
      window.removeEventListener("click", close);
    };
  }, []);

  const numbers = Array.from(
    { length: assessment.length },
    (_, index) => index + 1
  );

  const totalCount = assessment.length;
  const correctCount = Object.values(assessmentData).filter(
    (data) => data.status === "correct"
  ).length;
  const incorrectCount = Object.values(assessmentData).filter(
    (data) => data.status === "incorrect"
  ).length;
  const skippedCount = Object.values(assessmentData).filter(
    (data) => data.status === "skipped"
  ).length;

  const handleOptionClick = (option, index) => {
    const uniqueId = currentAssessment.unique_id;
    const isMultiSelect = currentAssessment.isMultiSelect;

    setAssessmentData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || [];
      let newAnswers;

      if (isMultiSelect) {
        if (prevAnswers.includes(option)) {
          newAnswers = prevAnswers.filter((ans) => ans !== option);
        } else {
          newAnswers = [...prevAnswers, option];
        }
      } else {
        newAnswers = [option];
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
        },
      };
    });

    setSelectedOptions((prev) => {
      if (isMultiSelect) {
        const selectedIndexes = prev[uniqueId] || [];
        return {
          ...prev,
          [uniqueId]: selectedIndexes.includes(index)
            ? selectedIndexes.filter((i) => i !== index)
            : [...selectedIndexes, index],
        };
      } else {
        return {
          ...prev,
          [uniqueId]: [index],
        };
      }
    });
  };

  const handleInputChange = (index, value) => {
    const uniqueId = currentAssessment.unique_id;
    setAssessmentData((prev) => {
      const updatedAnswers = [...(prev[uniqueId]?.answers || [])];
      updatedAnswers[index] = value;
      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const formatQuestionText = (text) => {
    let formattedText = text
      .replace(/<\/?p>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/(<br\s*\/?>\s*)+/g, "<br>")
      .replace(/‘|’/g, "'")
      .replace(/“|”/g, '"')
      .trim();

    console.log("Formatted Text:", formattedText);
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };

  const stripHtmlForCompare = (value) =>
    String(value ?? "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  const isDragDropCellIncorrect = (incorrectIndexes, colIndex, rowIndex) => {
    if (!Array.isArray(incorrectIndexes)) return false;
    return incorrectIndexes.some(
      (entry) =>
        Number(entry?.column) === colIndex && Number(entry?.row) === rowIndex
    );
  };

  const getDragDropTableCellClass = () => style.tableCell;

  const getDragDropCardInCellClass = (
    answered,
    incorrectIndexes,
    colIndex,
    rowIndex,
    cellValue,
    sentenceType
  ) => {
    const classes = [style.cardInCell];
    if (sentenceType) classes.push(style.cardInCellSentence);
    if (!answered) return classes.join(" ");

    if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
      classes.push(style.wrongCard);
    } else if (stripHtmlForCompare(cellValue)) {
      classes.push(style.correctCard);
    }
    return classes.join(" ");
  };

  const renderDragDropTableBody = ({
    columns,
    answered,
    incorrectIndexes,
    sentenceType,
    onDragOver,
    onDrop,
    onDelete,
  }) => {
    const rowCount = columns?.[0]?.values?.length || 0;

    return [...Array(rowCount)].map((_, rowIndex) => (
      <tr key={rowIndex}>
        {columns.map((col, colIndex) => {
          const cellValue = col.values[rowIndex];
          const hasCellValue = Boolean(stripHtmlForCompare(cellValue));

          return (
            <td
              key={`${colIndex}-${rowIndex}`}
              className={getDragDropTableCellClass()}
              onDragOver={(event) => !answered && onDragOver?.(event)}
              onDrop={(event) =>
                !answered && onDrop?.(event, colIndex, rowIndex)
              }
            >
              {hasCellValue ? (
                <div
                  className={getDragDropCardInCellClass(
                    answered,
                    incorrectIndexes,
                    colIndex,
                    rowIndex,
                    cellValue,
                    sentenceType
                  )}
                  draggable={false}
                  onDragStart={(e) => e.preventDefault()}
                >
                  <span
                    className={style.cardText}
                    dangerouslySetInnerHTML={{ __html: cellValue }}
                  />
                  {onDelete && !answered && (
                    <AiOutlineDelete
                      className={style.deleteButton}
                      onClick={() => onDelete(colIndex, rowIndex)}
                    />
                  )}
                </div>
              ) : null}
            </td>
          );
        })}
      </tr>
    ));
  };

  const handleDeleteDroppedCellV2 = (colIndex, rowIndex, uniqueId) => {
    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[uniqueId].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: updatedAnswers,
        },
      };
    });
  };

  const renderDragDropTableBodyV2 = ({
    columns,
    answered,
    incorrectIndexes,
    onDelete,
    uniqueId,
  }) => {
    const rowCount = columns?.[0]?.values?.length || 0;

    return [...Array(rowCount)].map((_, rowIndex) => (
      <tr key={rowIndex}>
        {columns.map((col, colIndex) => {
          const cellValue = col.values[rowIndex];
          const hasCellValue = Boolean(cellValue && cellValue.trim());

          let cardClass = style.cardInSlotV2;
          if (answered) {
            if (isDragDropCellIncorrect(incorrectIndexes, colIndex, rowIndex)) {
              cardClass += ` ${style.cardInSlotIncorrectV2}`;
            } else if (hasCellValue) {
              cardClass += ` ${style.cardInSlotCorrectV2}`;
            }
          }

          return (
            <td
              key={`${colIndex}-${rowIndex}`}
              className={style.dragTableCellV2}
            >
              <div
                className={`${style.dropSlotV2} ${
                  activeDropTarget?.colIndex === colIndex &&
                  activeDropTarget?.rowIndex === rowIndex
                    ? style.dropSlotActiveV2
                    : ""
                }`}
                onDragOver={(event) => {
                  event.preventDefault();
                  if (!answered) {
                    setActiveDropTarget({ colIndex, rowIndex });
                  }
                }}
                onDragLeave={() => {
                  if (!answered) {
                    setActiveDropTarget(null);
                  }
                }}
                onDrop={(event) => {
                  event.preventDefault();
                  setActiveDropTarget(null);
                  if (!answered) {
                    const droppedValue = event.dataTransfer.getData("text/plain");
                    if (droppedValue) {
                      setAssessmentData((prev) => {
                        const updatedAnswers = [...prev[uniqueId].answers];
                        updatedAnswers[colIndex].values[rowIndex] = droppedValue;
                        return {
                          ...prev,
                          [uniqueId]: {
                            ...prev[uniqueId],
                            answers: updatedAnswers,
                          },
                        };
                      });
                    }
                  }
                }}
              >
                {hasCellValue ? (
                  <div className={cardClass}>
                    <p>{cellValue}</p>
                    {onDelete && !answered && (
                      <AiOutlineDelete
                        onClick={() => onDelete(colIndex, rowIndex)}
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </td>
          );
        })}
      </tr>
    ));
  };

  const renderQuestionWithInputs = (question) => {
    const parts = question.split(/\[blank (\d+)\]/);
    const uniqueId = currentAssessment.unique_id;
    const status = assessmentData[uniqueId]?.status;
    const answered = assessmentData[uniqueId]?.answered;
    const incorrectIndexes =assessmentData[uniqueId]?.incorrect_index || [];

    return (
      <p>
        {" "}
        {/* Flexbox container */}
        {parts.map((part, index) => {
          if (index % 2 === 1) {
            const blankIndex = parseInt(parts[index], 10) - 1;
            // let inputStyle = {};

            // if (status === "correct") {
            //   inputStyle = { color: "#00DFC7" };
            // } else if (status === "incorrect") {
            //   inputStyle = { color: "#FF2443" };
            // } else {
            //   inputStyle = { color: "#FF7A00" };
            // }
            const isWrong =answered &&incorrectIndexes.map(i => i - 1).includes(blankIndex);

            // Calculate dynamic width based on input value length
            const inputValue =
              assessmentData[uniqueId]?.answers[blankIndex] || "";
            const calculatedWidth = inputValue.length * 10 + 20;
            const inputWidth = `${Math.min(
              Math.max(calculatedWidth, 50),
              500
            )}px`;
            const inputStyle = answered
            ? { color: isWrong ? "#FF2443" : "#00DFC7" }
            : { color: "#FF7A00" };

            return (
              <React.Fragment key={index}>
                <input
                  spellCheck="false"
                  autoCorrect="off"
                  autoComplete="off"
                  type="text"
                  value={inputValue}
                  onChange={(e) =>
                    handleInputChange(blankIndex, e.target.value)
                  }
                  className={style.blankInput}
                  disabled={
                    assessmentData[currentAssessment.unique_id]?.answered
                  }
                  style={{ ...inputStyle, width: inputWidth }}
                />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={index}>
                {formatQuestionText(part)}
              </React.Fragment>
            );
          }
        })}
      </p>
    );
  };

  const renderQuestionWithDropdowns = (question, options) => {
    const uniqueId = currentAssessment.unique_id;
    const parts = question.split(/(\[dropdown-\d+\])/);
    const answered = assessmentData[uniqueId]?.answered;
    const incorrectIndexes =assessmentData[uniqueId]?.incorrect_index || [];

    return (
      <p>
        {parts.map((part, index) => {
          const dropdownMatch = part.match(/\[dropdown-(\d+)\]/);

          if (dropdownMatch) {
            const dropdownId = parseInt(dropdownMatch[1], 10);
            const dropdownOptions =
              options.find((option) => option.id === dropdownId)?.options || [];
            const isWrong = answered && incorrectIndexes.map(i => i - 1).includes(dropdownId - 1);

            return (
              <React.Fragment key={index}>
                <select
                  value={assessmentData[uniqueId]?.answers?.[dropdownId] || ""}
                  onChange={(e) => {
                    const newAnswers = {
                      ...(assessmentData[uniqueId]?.answers || {}),
                    };
                    newAnswers[dropdownId] = e.target.value;
                    setUnansweredSelectDropdowns((prev) =>
                      prev.filter((id) => id !== dropdownId)
                    );
                    setAssessmentData((prev) => ({
                      ...prev,
                      [uniqueId]: {
                        ...prev[uniqueId],
                        answers: newAnswers,
                      },
                    }));
                  }}
                  className={`${style.blankDropdown} ${
                    unansweredSelectDropdowns.includes(dropdownId)
                      ? style.blankDropdownMissing
                      : ""
                  }`}
                  disabled={
                    assessmentData[currentAssessment.unique_id]?.answered
                  }
                  style={
                    answered
                      ? isWrong
                        ? { color: "#FF2443" }
                        : { color: "#00DFC7" }
                      : { color: "#000" }
                  }
                >
                  <option disabled value="">
                    Select
                  </option>
                  {dropdownOptions.map((option, i) => (
                    <option
                      key={i}
                      value={option}
                      style={
                        answered
                          ? isWrong
                            ? { color: "#FF2443" }
                            : { color: "#00DFC7" }
                          : { color: "#000" }
                      }
                    >
                      {String(option || "")
                        .replace(/<[^>]*>/g, "")
                        .replace(/&nbsp;/gi, " ")
                        .replace(/\u00a0/g, " ")
                        .trim() || option}
                    </option>
                  ))}
                </select>
              </React.Fragment>
            );
          }
          return (
            <React.Fragment key={index}>
              {formatQuestionText(part)}
            </React.Fragment>
          );
        })}
      </p>
    );
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const sourceDroppableId = result.source.droppableId;
    const destinationDroppableId = result.destination.droppableId;
    const uniqueId = currentAssessment.unique_id;

    setAssessmentData((prev) => {
      const prevAnswers = prev[uniqueId]?.answers || { left: [], right: [] };
      const prevRightOrder =
        prev[uniqueId]?.rightOrder ||
        (prevAnswers.right || []).map((_, i) => i);

      let newAnswers = { ...prevAnswers };
      let newRightOrder = [...prevRightOrder];

      if (
        sourceDroppableId.startsWith("left") &&
        destinationDroppableId.startsWith("left")
      ) {
        const items = Array.from(newAnswers.left);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.left = items;
      } else if (
        sourceDroppableId.startsWith("right") &&
        destinationDroppableId.startsWith("right")
      ) {
        const items = Array.from(newAnswers.right);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        newAnswers.right = items;

        const [reorderedPos] = newRightOrder.splice(result.source.index, 1);
        newRightOrder.splice(result.destination.index, 0, reorderedPos);
      }

      return {
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newAnswers,
          rightOrder: newRightOrder,
        },
      };
    });
  };

  const handleArrangeDragEnd = (event) => {
    setIsDragging(false);
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const uniqueId = currentAssessment.unique_id;
    const items = [...(assessmentData[uniqueId]?.answers || [])];

    const oldIndex = items.findIndex(
      (_, index) => `option-${index}` === active.id
    );
    const newIndex = items.findIndex(
      (_, index) => `option-${index}` === over.id
    );

    if (oldIndex !== -1 && newIndex !== -1) {
      const newItems = arrayMove(items, oldIndex, newIndex);

      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: newItems,
        },
      }));
    }
  };

  const SortableItem = ({ id, option, index, incorrectIndexes, isSentenceType }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id });

    const styles = {
      transform: CSS.Transform.toString(transform),
      transition,
      touchAction: "none", // Prevents flickering
      position: "relative",
    };
    const isWrong =assessmentData[currentAssessment.unique_id]?.answered &&incorrectIndexes?.map((i) => i - 1).includes(index);
    const isCorrect = assessmentData[currentAssessment.unique_id]?.answered && !isWrong;

    return (
      <div
        ref={setNodeRef}
        style={styles}
        {...attributes}
        {...listeners}
        className={`${style.reArrangeCard} ${
          isSentenceType ? style.reArrangeCardSentence : ""
        } ${
          isSentenceType && (isWrong || isCorrect)
            ? style.reArrangeSentenceResultDotted
            : ""
        } ${
          isWrong ? style.wrongCard : ""
        } ${
          isCorrect ? style.correctCard : ""
        }
        ${
          isDragging ? style.reArrangeCardDragging : ""
        }`}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: String(option ?? "")
              .replace(/<p>/gi, "")
              .replace(/<\/p>/gi, "")
              .replace(/&nbsp;/g, " "),
          }}
        />
        {isDragging && <div className={style.dragIndicator}></div>}
      </div>
    );
  };

  const handleCellValueChange = (
    rowIndex,
    colIndex,
    value,
    clueID,
    clueNumber
  ) => {
    const uniqueId = currentAssessment.unique_id;

    setAssessmentData((prevData) => {
      const newAnswers =
        prevData[uniqueId]?.answers.map((row, i) =>
          row.map((cell, j) =>
            i === rowIndex && j === colIndex
              ? { ...cell, cluevalue: value.toUpperCase(), clueID, clueNumber }
              : cell
          )
        ) || [];

      return {
        ...prevData,
        [uniqueId]: {
          ...prevData[uniqueId],
          answers: newAnswers,
        },
      };
    });
    const rows = assessmentData[uniqueId]?.answers.length || 0;
    const cols = assessmentData[uniqueId]?.answers[0]?.length || 0;

    let nextRowIndex = rowIndex + 1;
    let nextColIndex = colIndex;

    if (nextRowIndex >= rows) {
      nextColIndex += 1;
      nextRowIndex = 0;
    }
    if (
      nextRowIndex < rows &&
      inputRefs.current[uniqueId]?.[nextRowIndex * cols + nextColIndex]
    ) {
      const nextInputRef =
        inputRefs.current[uniqueId][nextRowIndex * cols + nextColIndex];
      if (nextInputRef) {
        nextInputRef.focus();
      }
    }
  };

  const getBackgroundColor = (status) => {
    switch (status) {
      case "correct":
        return "#00DFC7";
      case "incorrect":
        return "#FF7C8E";
      default:
        return "transparent";
    }
  };

  const getHighlightColor = (status) => {
    switch (status) {
      case "correct":
        return "#00FFC1";
      case "incorrect":
        return "#FF7C8E";
      default:
        return "#FF7A00";
    }
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex + 1);
    setValidateClicked(false);
    setSubmitLoading(false);
  };

  const handleSkip = () => {
    const uniqueId = currentAssessment?.unique_id;
    if (assessmentData[uniqueId]?.status === "viewed") {
      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          status: "skipped",
        },
      }));
    }

    if (uniqueId && assessmentData[uniqueId]) {
      const currentAssmnt = assessment[currentIndex];
      let resetAnswers;
      let resetHighlightContent = "";
      let resetLastSelectedText = "";
      let resetAcrossClues = [];
      let resetDownClues = [];
      let highlightMultipleContent = "";

      let resetRightOrder = [];
      if (
        currentAssmnt.type === "Match the following" ||
        currentAssmnt.type === "Match the following with image"
      ) {
        const filteredLeft = (currentAssmnt.left || []).filter(
          (leftData) => leftData.trim() !== ""
        );
        const filteredRight = (currentAssmnt.right || []).filter(
          (rightData) => rightData.trim() !== ""
        );
        resetAnswers = {
          left: filteredLeft,
          right: filteredRight,
        };
        resetRightOrder = filteredRight.map((_, i) => i);
      } else if (currentAssmnt.type === "Rearrange") {
        resetAnswers = currentAssmnt.options || [];
      } else if (currentAssmnt.type === "cross word puzzle") {
        resetAnswers = currentAssmnt.options.map((row) =>
          row.map((cell) => ({
            clueID: cell.clueID || "",
            clueNumber: cell.clueNumber,
            cluevalue: "",
            disabled: cell.cluevalue === "",
          }))
        );

        resetAcrossClues = currentAssmnt.left.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
        resetDownClues = currentAssmnt.right.map((clueObj) => ({
          id: clueObj.id,
          number: clueObj.number,
          clue: clueObj.clue,
          answer: "",
        }));
      } else if (currentAssmnt.type === "highlight") {
        resetHighlightContent =
          currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          ) || "";
        resetHighlightContent =
          resetHighlightContent.replace(/<span[^>]*>(.*?)<\/span>/g, "$1") ||
          "";

        resetLastSelectedText = "";
      } else if (currentAssmnt.type === "highlight_multiple") {
        highlightMultipleContent = currentAssmnt.options.replace(
          /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
          "$1"
        );

        highlightMultipleContent = highlightMultipleContent.replace(
          /<span[^>]*>(.*?)<\/span>/g,
          "$1"
        );
        resetAnswers = [];
      } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
        const updatedAnswer = currentAssmnt.answer.map((item) => {
          return {
            ...item,
            values: item.values.map(() => ""),
          };
        });
        resetAnswers = updatedAnswer;
      } else {
        resetAnswers = [];
      }

      setAssessmentData((prev) => ({
        ...prev,
        [uniqueId]: {
          ...prev[uniqueId],
          answers: resetAnswers,
          rightOrder: resetRightOrder,
          highlightContent: resetHighlightContent,
          lastSelectedText: resetLastSelectedText,
          cluesAcross: resetAcrossClues,
          cluesDown: resetDownClues,
          previousRange: null,
          highlightMultipleContent: highlightMultipleContent,
          highlightMultipleRange: [],
        },
      }));
      setSelectedOptions((prev) => {
        const { [uniqueId]: _, ...rest } = prev;
        return rest;
      });
    }

    // Proceed to next question
    setCurrentIndex((prevIndex) => prevIndex + 1);
    setValidateClicked(false);
  };

  const handleDragStart = (event, option) => {
    event.dataTransfer.setData("text/plain", option);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, colIndex, rowIndex) => {
    event.preventDefault();
    const droppedValue = event.dataTransfer.getData("text/plain");

    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[currentAssessment.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = droppedValue;

      return {
        ...prev,
        [currentAssessment.unique_id]: {
          ...prev[currentAssessment.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };

  const handleDeleteDroppedCell = (colIndex, rowIndex) => {
    setAssessmentData((prev) => {
      const updatedAnswers = [...prev[currentAssessment.unique_id].answers];
      updatedAnswers[colIndex].values[rowIndex] = ""; // Clear the dropped value

      return {
        ...prev,
        [currentAssessment.unique_id]: {
          ...prev[currentAssessment.unique_id],
          answers: updatedAnswers,
        },
      };
    });
  };
  const renderFillBlankQuestionWithAnswer = (question, actualAns = []) => {
  if (!question) return null;

  const answerByKey = {};
  const fallbackValues = [];

  (Array.isArray(actualAns) ? actualAns : [actualAns]).forEach((answerObj) => {
    if (!answerObj || typeof answerObj !== "object") return;
    Object.entries(answerObj).forEach(([rawKey, rawValue]) => {
      const value = String(rawValue ?? "").trim();
      fallbackValues.push(value);
      const numericKey = Number(rawKey);
      if (!Number.isNaN(numericKey)) {
        answerByKey[numericKey] = value;
      }
    });
  });

  let fallbackIndex = 0;
  const filledQuestion = question.replace(
    /\[blank\s*(\d+)\s*\]/gi,
    (_, blankNo) => {
      const key = Number(blankNo);
      const mappedAnswer =
        answerByKey[key] ??
        answerByKey[key - 1] ??
        fallbackValues[fallbackIndex++] ??
        "";
      return `<span>${mappedAnswer}</span>`;
    }
  );

  return (
    <div className={style.fillBlankAnswer} dangerouslySetInnerHTML={{ __html: filledQuestion }} />
  );
};

const renderSelectAnswersQuestionWithAnswer = (question, actualAns = []) => {
  if (!question) return null;
  const answerByKey = {};
  const fallbackValues = [];

  actualAns.forEach((answerObj) => {
    Object.entries(answerObj || {}).forEach(([rawKey, rawValue]) => {
      const value = String(rawValue ?? "").trim();
      fallbackValues.push(value);
      const numericKey = Number(rawKey);
      if (!Number.isNaN(numericKey)) {
        answerByKey[numericKey] = value;
      }
    });
  });

  let fallbackIndex = 0;
  const filledQuestion = question.replace(/\[dropdown-(\d+)\]/g, (_, dropdownNo) => {
    const key = Number(dropdownNo);
    const mappedAnswer =
      answerByKey[key] ??
      answerByKey[key - 1] ??
      fallbackValues[fallbackIndex++] ??
      "";
    return `<span class="${style.selectAnswerBox}">${mappedAnswer}</span>`;
  });

  return (
    <div
      className={style.fillBlankAnswer}
      dangerouslySetInnerHTML={{ __html: filledQuestion }}
    />
  );
};

const escapeRegex = (value = "") =>
  String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const HIGHLIGHT_ANSWER_COLOR = "rgb(255, 122, 0)";

const normalizeHighlightAnswerHtml = (html = "") => {
  if (!html) return "";
  return String(html).replace(
    /color:\s*(#ff7a00|#FF7A00|rgb\(\s*255\s*,\s*122\s*,\s*0\s*\))/gi,
    `color: ${HIGHLIGHT_ANSWER_COLOR}`
  );
};

const getHighlightMultipleAnswers = (ranges = [], html = "") => {
  if (!ranges.length || !html) return [];
  return [normalizeHighlightAnswerHtml(html)];
};

const normalizeHighlightMultipleCorrectIndex = (correctIndex = []) => {
  if (!Array.isArray(correctIndex)) return [];

  return correctIndex
    .map((item) => {
      if (item && typeof item === "object" && item.start != null && item.end != null) {
        return {
          start: Number(item.start),
          end: Number(item.end),
          text: String(item.text ?? ""),
        };
      }
      return null;
    })
    .filter((item) => item && item.end > item.start)
    .sort((a, b) => a.start - b.start);
};

const wrapTextRangeInNode = (doc, textNode, localStart, localEnd, color) => {
  const text = textNode.nodeValue || "";
  const before = text.slice(0, localStart);
  const middle = text.slice(localStart, localEnd);
  const after = text.slice(localEnd);
  const fragment = doc.createDocumentFragment();

  if (before) fragment.appendChild(doc.createTextNode(before));
  const span = doc.createElement("span");
  span.style.color = color;
  span.textContent = middle;
  fragment.appendChild(span);
  if (after) fragment.appendChild(doc.createTextNode(after));

  textNode.parentNode?.replaceChild(fragment, textNode);
};

const highlightRangesInHtml = (
  html = "",
  ranges = [],
  color = "rgb(0, 223, 199)"
) => {
  const normalizedRanges = normalizeHighlightMultipleCorrectIndex(ranges);
  if (!html || !normalizedRanges.length || typeof document === "undefined") {
    return html || "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return html || "";

  const sortedRanges = [...normalizedRanges].sort((a, b) => b.start - a.start);

  sortedRanges.forEach(({ start, end }) => {
    const walker = doc.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT, null);
    let globalOffset = 0;
    let textNode;
    const segmentsToWrap = [];

    while ((textNode = walker.nextNode())) {
      const nodeText = textNode.nodeValue || "";
      const nodeStart = globalOffset;
      const nodeEnd = globalOffset + nodeText.length;
      globalOffset = nodeEnd;

      const rangeStart = Math.max(start, nodeStart);
      const rangeEnd = Math.min(end, nodeEnd);
      if (rangeStart >= rangeEnd) continue;

      segmentsToWrap.push({
        node: textNode,
        localStart: rangeStart - nodeStart,
        localEnd: rangeEnd - nodeStart,
      });
    }

    segmentsToWrap.reverse().forEach(({ node, localStart, localEnd }) => {
      wrapTextRangeInNode(doc, node, localStart, localEnd, color);
    });
  });

  return wrapper.innerHTML;
};

const highlightTermsInHtml = (
  html = "",
  terms = [],
  color = "rgb(0, 223, 199)"
) => {
  const normalizedTerms = (terms || [])
    .map((term) => String(term ?? "").trim())
    .filter((term) => term.length > 0)
    .sort((a, b) => b.length - a.length);

  if (!html || normalizedTerms.length === 0 || typeof document === "undefined") {
    return html || "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, "text/html");
  const wrapper = doc.body.firstElementChild;
  if (!wrapper) return html || "";

  const regex = new RegExp(normalizedTerms.map(escapeRegex).join("|"), "gi");
  const walker = doc.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((textNode) => {
    const text = textNode.nodeValue || "";
    regex.lastIndex = 0;
    if (!regex.test(text)) return;

    regex.lastIndex = 0;
    const fragment = doc.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(
          doc.createTextNode(text.slice(lastIndex, match.index))
        );
      }
      const span = doc.createElement("span");
      span.style.color = color;
      span.textContent = match[0];
      fragment.appendChild(span);
      lastIndex = regex.lastIndex;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }
    textNode.parentNode?.replaceChild(fragment, textNode);
  });

  return wrapper.innerHTML;
};

const renderHighlightQuestionWithAnswer = (
  questionHtml,
  actualAns = [],
  correctIndex = [],
  questionType = ""
) => {
  const highlightedQuestion =
    questionType === "highlight_multiple"
      ? highlightRangesInHtml(questionHtml || "", correctIndex, "rgb(0, 223, 199)")
      : highlightTermsInHtml(
          questionHtml || "",
          correctIndex,
          "rgb(0, 223, 199)"
        );

  return (
    <div className={style.fillBlankAnswer}>
      <div
        dangerouslySetInnerHTML={{
          __html: highlightedQuestion,
        }}
      />
    </div>
  );
};




  async function assessmentGet() {
    await fetch(`${baseurl}/ai/assignment/generation/for/user/new`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: OrgID,
        topic_id: Topic.id,
        topic_name: Topic.value,
        learning_id: learning_id,
        main_topic_id: main_topic_id,
        user_id: USERID,
        admin_mapped: "true",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          const modifiedAssessments = data.data[0]?.assessments.map(
            (assessment, index) => {
              const baseQuestion = {
                ...assessment,
                question_no: index + 1,
              };
              if (
                assessment.type === "Match the following" ||
                assessment.type === "Match the following with image"
              ) {
                return {
                  ...baseQuestion,
                  draggable: "right",
                };
              } else if (assessment.type === "multiple choices") {
                const isMultiSelect = assessment.answer.length > 1;
                return {
                  ...baseQuestion,
                  isMultiSelect,
                };
              } else if (
                assessment.type === "fill in the blanks" ||
                assessment.type === "select the answers"
              ) {
                return {
                  ...baseQuestion,
                  question: assessment.question.replace(/<\/p>/g, "</p><br/>"),
                };
              }
              return baseQuestion;
            }
          );

          setAssessment(modifiedAssessments);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        } else {
          setAssessment([]);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      });
  }

  async function assessmentAnswer() {
    const questionId = currentAssessment.id
      ? currentAssessment.id.toString()
      : "";
    let answerToSend;
    if (
      currentAssessment.type === "Match the following" ||
      currentAssessment.type === "Match the following with image"
    ) {
      if (currentAssessment.draggable === "right") {
        answerToSend =
          assessmentData[currentAssessment.unique_id]?.answers?.right || [];
      } else if (currentAssessment.draggable === "left") {
        answerToSend =
          assessmentData[currentAssessment.unique_id]?.answers?.left || [];
      }
    } else if (currentAssessment.type === "cross word puzzle") {
      answerToSend = assessmentData[currentAssessment.unique_id]?.answers.map(
        (answerGroup) =>
          Array.isArray(answerGroup)
            ? answerGroup.map((answer) => ({
                clueID: answer.clueID,
                clueNumber: answer.clueNumber,
                cluevalue: answer.cluevalue,
              }))
            : answerGroup
      );
    } else if (currentAssessment.type === "highlight") {
      const highlightHtml =
        assessmentData[currentAssessment.unique_id]?.highlightContent || "";
      answerToSend = highlightHtml
        ? [normalizeHighlightAnswerHtml(highlightHtml)]
        : [];
    } else if (currentAssessment.type === "highlight_multiple") {
      const uniqueId = currentAssessment.unique_id;
      const ranges = assessmentData[uniqueId]?.highlightMultipleRange || [];
      const highlightHtml =
        assessmentData[uniqueId]?.highlightMultipleContent || "";
      answerToSend = getHighlightMultipleAnswers(ranges, highlightHtml);
    } else if (currentAssessment.type === "fill in the blanks") {
      const rawAnswers =
      assessmentData[currentAssessment.unique_id]?.answers || [];
      
      const cleanedAnswers = rawAnswers
        .map((ans) => (typeof ans === "string" ? ans.trim() : ""))
        .filter((ans) => ans !== "");
      const orderedBlanks = [
        ...currentAssessment.question.matchAll(/\[blank\s*(\d+)\]/g),
      ].map((m) => m[1]);
      const sortedBlanks = [...orderedBlanks].sort(
        (a, b) => Number(a) - Number(b)
      ); 
      answerToSend = sortedBlanks.map((num) => {
        const visualIndex = orderedBlanks.indexOf(num);
        return visualIndex >= 0 ? cleanedAnswers[visualIndex] || "" : "";
    });
    } else if (currentAssessment.type === "select the answers") {
      const answersObj =
        assessmentData[currentAssessment.unique_id]?.answers || {};
      answerToSend =
        Object.values(answersObj).length > 0 ? Object.values(answersObj) : [];
    } else {
      answerToSend = assessmentData[currentAssessment.unique_id]?.answers || [];
    }

    await fetch(`${baseurl}/user/assignment/answers/validation`, {
      method: "POST",
      body: JSON.stringify({
        Organization_ID: userDetails && userDetails.org_id,
        topic_id: Topic.id,
        topic_name: Topic.value,
        question: currentAssessment.question,
        question_id: questionId,
        answer: answerToSend,
        ai_id: aiID,
        main_topic_id: main_topic_id,
        user_id: userDetails && userDetails._id?.$oid,
        question_type: currentAssessment.type,
        case_sensitive:
          currentAssessment.type === "fill in the blanks"
            ? currentAssessment.case_sensitive ?? false
            : false,
        shuffled_answer:
          currentAssessment.type === "fill in the blanks"
            ? currentAssessment.shuffled_answer ?? false
            : false,
        options:
          currentAssessment.type === "highlight" ||
          currentAssessment.type === "highlight_multiple"
            ? Array.isArray(currentAssessment.options)
              ? currentAssessment.options
              : currentAssessment.options
              ? [currentAssessment.options]
              : []
            : Array.isArray(currentAssessment.options)
            ? currentAssessment.options
            : currentAssessment.options
            ? [currentAssessment.options]
            : [],
        unique_id: currentAssessment.unique_id,
        generated_by: currentAssessment.generation === "admin" ? "admin" : "",
        left: currentAssessment.left ? currentAssessment.left : [],
        right: currentAssessment.right ? currentAssessment.right : [],
        actual_ans:
          currentAssessment.type === "cross word puzzle"
            ? currentAssessment.options
            : currentAssessment.answer,
        question_explained: currentAssessment.question_explained,
        time_taken: "",
        markif_correct: currentAssessment.mark,
        markif_incorrect: currentAssessment.negative_mark,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const isCorrect = data.data[0].answer_is === "Correct";
        const newStatus = isCorrect ? "correct" : "incorrect";
        const resultMessage = isCorrect
          ? CORRECT_MESSAGES[correctMsgIndexRef.current % CORRECT_MESSAGES.length]
          : INCORRECT_MESSAGES[incorrectMsgIndexRef.current % INCORRECT_MESSAGES.length];
        if (isCorrect) {
          correctMsgIndexRef.current += 1;
        } else {
          incorrectMsgIndexRef.current += 1;
        }
        let sanitizedExplanation = data.data[0]?.question_explained;
        if (sanitizedExplanation === "<p><br></p>") {
          sanitizedExplanation = "";
        }
        setWrongAnswerCount((prev) => {
          const newCount = isCorrect ? 0 : prev + 1;
          if (newCount >= 3) setFailedPopup(true);
          return newCount;
        });
        const matchFieldExists = data.data[0]?.match !== undefined;
        const rawCorrectIndex =
          data.correct_index || data.data[0]?.correct_index || [];
        const normalizedCorrectIndex =
          currentAssessment.type === "highlight_multiple"
            ? normalizeHighlightMultipleCorrectIndex(rawCorrectIndex)
            : rawCorrectIndex;

        setAssessmentData((prev) => ({
          ...prev,
          [currentAssessment.unique_id]: {
            ...prev[currentAssessment.unique_id],
            status: newStatus,
            resultMessage,
            explanations: sanitizedExplanation,
            answered: true,
            ...(matchFieldExists && { match: data.data[0].match }),
            actual_ans: data.data[0]?.actual_ans,
            left: data.data[0]?.left,
            right: data.data[0]?.right,
            question_type: data.data[0]?.question_type,
            incorrect_index: data.incorrect_index || [],
            correct_index: normalizedCorrectIndex,
          },
        }));
        setValidateClicked(true);
      })
      .catch((error) => {
        console.error("API call failed:", error);
        setValidateClicked(false);
        setSubmitLoading(false);
        setSubmitError(true); // Fallback for failed request
        // fallback on failure
      });
  }

  async function endAssessment() {
    await fetch(`${baseurl}/assement/end-batch-test`, {
      method: "POST",
      body: JSON.stringify({
        learning_id: learning_id,
        topic_id: Topic.id,
        user_id: userDetails && userDetails._id?.$oid,
        main_topic_id: main_topic_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setResult(true);
          setSummaryDetail(data.data);
          setCarouselData(data.data?.awards);
          const coinsArray = data.data?.coins || [];
          const coinsSum = coinsArray.reduce(
            (sum, coin) => sum + Number(coin),
            0
          ); // Ensure coins are converted to numbers
          setPoints(coinsSum);
          setFinishPopup(false);
          setPopupMsg(data.data?.popup_message);
          setTimeout(() => {
            setShowPopupMsg(false);
            setCoinsAnimation(false);
            setCoinsLossAnimation(false);
            setAchievementPopup(false);            
            // Check if awards array exists and is not empty
            if (data.data?.awards && data.data.awards.length > 0) {
              setAchievementPopup(true);
            }
            else if (coinsSum > 0) {
                  setCoinsAnimation(true);     
                } 
            else if (coinsSum < 0) {
                  setCoinsLossAnimation(true);  
                }
            if (data.data?.popup_message) {
              setPopupMsg(data.data?.popup_message);
              setShowPopupMsg(true);
            }
          }, 1000);
        }
      });
  }

  const explanationWithDefaultImageSize = assessmentData[
    currentAssessment.unique_id
  ]?.explanations.replace(/<img(.*?)>/g, '<img$1 width="200" height="auto">');

  useEffect(() => {
    if (USERID) {
      assessmentGet();
    }
  }, [USERID]);

  const handleSelectionChange = (range, oldRange, source) => {
    const quill = quillRef.current.getEditor();
    const uniqueId = currentAssessment.unique_id;

    if (range && range.length > 0) {
      const selectedText = quill.getText(range.index, range.length).trim();
      const currentData = assessmentData[uniqueId];
      const status = currentData.status;
      const previousRange = currentData.previousRange;
      if (
        previousRange &&
        previousRange.index === range.index &&
        previousRange.length === range.length
      ) {
        quill.formatText(range.index, range.length, "color", false);
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: null,
            lastSelectedText: "",
            highlightContent: quill.root.innerHTML,
          },
        }));
      } else {
        if (previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            false
          );
        }
        const highlightColor = getHighlightColor(status);
        quill.formatText(range.index, range.length, "color", highlightColor);
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            previousRange: range,
            lastSelectedText: selectedText,
            highlightContent: quill.root.innerHTML,
          },
        }));
      }
    }
  };

  const handleMultipleSelectionChange = (range, oldRange, source) => {
    const quill = quillRef.current.getEditor();
    const uniqueId = currentAssessment.unique_id;

    if (range && range.length > 0) {
      let selectedText = quill.getText(range.index, range.length).trim();
      selectedText = selectedText.endsWith(".")
        ? selectedText.slice(0, -1)
        : selectedText;
      if (!selectedText) return;

      const currentData = assessmentData[uniqueId];
      const highlightColor = getHighlightColor(currentData.status);
      const currentRanges = currentData.highlightMultipleRange || [];
      const existingRangeIndex = currentRanges.findIndex(
        (r) => r.index === range.index && r.length === range.length
      );

      if (existingRangeIndex !== -1) {
        quill.formatText(range.index, range.length, "color", false);

        const updatedRanges = [...currentRanges];
        updatedRanges.splice(existingRangeIndex, 1);
        const updatedContent = quill.root.innerHTML;

        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      } else {
        const overlappingRanges = currentRanges.filter(
          (r) =>
            r.index < range.index + range.length &&
            range.index < r.index + r.length
        );

        let updatedRanges = [...currentRanges];
        overlappingRanges.forEach((overlappingRange) => {
          quill.formatText(
            overlappingRange.index,
            overlappingRange.length,
            "color",
            false
          );

          updatedRanges = updatedRanges.filter(
            (r) =>
              r.index !== overlappingRange.index ||
              r.length !== overlappingRange.length
          );
        });
        quill.formatText(range.index, range.length, "color", highlightColor);
        updatedRanges.push({
          index: range.index,
          length: range.length,
          text: selectedText,
        });
        const updatedContent = quill.root.innerHTML;
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...currentData,
            highlightMultipleRange: updatedRanges,
            highlightMultipleContent: updatedContent,
            answers: getHighlightMultipleAnswers(updatedRanges, updatedContent),
          },
        }));
      }
    }
  };

  const handleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = assessment[currentIndex]?.unique_id;
    setAssessmentData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightContent: value,
      },
    }));
  };

  const handleHighlightMultipleQuillChange = (value) => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const container = quill.root.parentElement;
      container.style.border = "none";
      container.style.boxShadow = "none";
    }
    const uniqueId = assessment[currentIndex]?.unique_id;
    setAssessmentData((prev) => ({
      ...prev,
      [uniqueId]: {
        ...prev[uniqueId],
        highlightMultipleContent: value,
      },
    }));
  };

  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const uniqueId = currentAssessment.unique_id;
      const status = assessmentData[uniqueId]?.status;
      const previousRange = assessmentData[uniqueId]?.previousRange;
      const highlightMultipleRange =
        assessmentData[uniqueId]?.highlightMultipleRange || [];

      if (quill && status) {
        const highlightColor = getHighlightColor(status);

        if (currentAssessment.type === "highlight" && previousRange) {
          quill.formatText(
            previousRange.index,
            previousRange.length,
            "color",
            highlightColor
          );
        }
        if (
          currentAssessment.type === "highlight_multiple" &&
          highlightMultipleRange.length > 0
        ) {
          highlightMultipleRange.forEach((range) => {
            quill.formatText(
              range.index,
              range.length,
              "color",
              highlightColor
            );
          });
        }
      }
    }
  }, [assessmentData[currentAssessment.unique_id]?.status]);

  useEffect(() => {
    if (assessment.length > 0) {
      const currentAssmnt = assessment[currentIndex];
      const uniqueId = currentAssmnt?.unique_id;

      setCurrentAssessment(currentAssmnt);

      if (!assessmentData[uniqueId]) {
        let initialAnswers;
        let initialAcrossClues = [];
        let initialDownClues = [];
        let highlightContent = "";
        let lastSelectedText = "";
        let highlightMultipleContent = "";

        let initialRightOrder = [];
        if (
          currentAssmnt.type === "Match the following" ||
          currentAssmnt.type === "Match the following with image"
        ) {
          const filteredLeft = (currentAssmnt.left || []).filter(
            (leftData) => leftData.trim() !== ""
          );
          const filteredRight = (currentAssmnt.right || []).filter(
            (rightData) => rightData.trim() !== ""
          );
          initialAnswers = {
            left: filteredLeft,
            right: filteredRight,
          };
          initialRightOrder = filteredRight.map((_, i) => i);
        } else if (currentAssmnt.type === "Rearrange") {
          initialAnswers = currentAssmnt.options || [];
        } else if (currentAssmnt.type === "cross word puzzle") {
          const grid = currentAssmnt.options.map((row) =>
            row.map((cell) => ({
              clueID: cell.clueID || "",
              clueNumber: cell.clueNumber,
              cluevalue: "",
              disabled: cell.cluevalue === "",
            }))
          );
          initialAnswers = grid;

          initialAcrossClues = currentAssmnt.left.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
          initialDownClues = currentAssmnt.right.map((clueObj) => ({
            id: clueObj.id,
            number: clueObj.number,
            clue: clueObj.clue,
            answer: "",
          }));
        } else if (currentAssmnt.type === "highlight") {
          // Remove color style from any tag containing `color: rgb(255, 122, 0);`
          highlightContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );

          // Remove any remaining <span> tags, if needed
          highlightContent = highlightContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );

          lastSelectedText = "";
        } else if (currentAssmnt.type === "highlight_multiple") {
          highlightMultipleContent = currentAssmnt.options.replace(
            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
            "$1"
          );

          highlightMultipleContent = highlightMultipleContent.replace(
            /<span[^>]*>(.*?)<\/span>/g,
            "$1"
          );
          initialAnswers = [];
        } else if (currentAssmnt.type === "Drag and Drop" || currentAssmnt.type === "drag and drop_v2") {
          const updatedAnswer = currentAssmnt.answer.map((item) => {
            return {
              ...item,
              values: item.values.map(() => ""),
            };
          });
          initialAnswers = updatedAnswer;
        } else {
          initialAnswers = [];
        }

        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            answers: initialAnswers,
            rightOrder: initialRightOrder,
            status: "",
            explanations: "",
            cluesAcross: initialAcrossClues,
            cluesDown: initialDownClues,
            highlightContent: highlightContent,
            lastSelectedText: lastSelectedText,
            previousRange: null,
            highlightMultipleContent: highlightMultipleContent,
            highlightMultipleRange: [],
          },
        }));
      } else if (!assessmentData[uniqueId]?.status) {
        setAssessmentData((prev) => ({
          ...prev,
          [uniqueId]: {
            ...prev[uniqueId],
            status: "viewed",
          },
        }));
      }
    }
  }, [currentIndex, assessment, assessmentData]);

  useEffect(() => {
    if (currentAssessment) {
      if (!inputRefs.current[currentAssessment.unique_id]) {
        inputRefs.current[currentAssessment.unique_id] = [];
      }
    }
  }, [currentAssessment]);

  useEffect(() => {
    setUnansweredSelectDropdowns([]);
  }, [currentAssessment?.unique_id]);

  useEffect(() => {
    const userType =
      userStatus === "succeeded" && userDetails && userDetails.user_type;

    if (userType === "Trail") {
      setTrailUser(true);
    } else {
      setTrailUser(false);
    }
  }, []);

  // Handle outside click for hint dialog
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (hintRef.current && !hintRef.current.contains(event.target)) {
        setHintDialog(false);
        setShowHint(false);
      }
    };

    if (hintDialog) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hintDialog]);

  // Update result ref when result state changes
  useEffect(() => {
    resultRef.current = result;
  }, [result]);

  // Update navigation data ref when navigation data changes
  useEffect(() => {
    navigationDataRef.current = {
      singleTopic: Topic,
      learning: learning_id,
      mapped: admin_Mapped_Lessons,
      mainId: main_topic_id,
      topic_no: topicNo,
      userID: USERID,
      orgID: OrgID,
    };
  }, [Topic, learning_id, admin_Mapped_Lessons, main_topic_id, topicNo, USERID, OrgID]);

  // Handle browser back button and page navigation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Only prevent leaving if test is not finished
      if (!resultRef.current) {
        e.preventDefault();
        e.returnValue = "Your test will end. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    const handlePopState = (e) => {
      // If test is already finished (result screen showing), navigate directly
      if (resultRef.current) {
        navigate("/new/learnings/detail", {
          state: navigationDataRef.current
        });
      } else {
        // If test is still in progress, show warning popup
        setBackButtonWarning(true);
        // Push state again to prevent navigation until user confirms
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Store handler references
    beforeUnloadHandlerRef.current = handleBeforeUnload;
    popStateHandlerRef.current = handlePopState;

    // Push initial state to history
    window.history.pushState(null, "", window.location.href);

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      // Clean up event listeners
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle user decision on back button warning
  const handleStayOnPage = () => {
    setBackButtonWarning(false);
  };

  const handleLeavePage = async () => {
    setBackButtonWarning(false);
    // Remove event listeners before navigating
    if (beforeUnloadHandlerRef.current) {
      window.removeEventListener("beforeunload", beforeUnloadHandlerRef.current);
    }
    if (popStateHandlerRef.current) {
      window.removeEventListener("popstate", popStateHandlerRef.current);
    }
    
    // Call endAssessment API without showing result screen
    try {
      const response = await fetch(`${baseurl}/assement/end-batch-test`, {
        method: "POST",
        body: JSON.stringify({
          learning_id: learning_id,
          topic_id: Topic.id,
          user_id: userDetails && userDetails._id?.$oid,
          main_topic_id: main_topic_id,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
      });
      
      const data = await response.json();
      
      // Navigate back after API success, without showing result screen
      if (data.status === true) {
        navigate("/new/learnings/detail", {
          state: navigationDataRef.current
        });
      }
    } catch (error) {
      console.error("Error ending assessment:", error);
      // Navigate anyway even if API fails
      navigate("/new/learnings/detail", {
        state: navigationDataRef.current
      });
    }
  };

  const handleSubmitLog = async (questionId, questionType, buttonState) => {
    const userId = localStorage.getItem("USERID");
    const logData = {
      question_id: questionId,
      question_type: questionType,
      button_state: buttonState,
      conditions: {
        validateClicked,
        isAlreadyAnswered:
          assessmentData[currentAssessment.unique_id]?.answered,
        hasAnswers:
          assessmentData[currentAssessment.unique_id]?.answers?.length > 0,
      },
    };

    try {
      await fetch(`${baseurl}/submit-log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDetails && userDetails.auth_token}`,
        },
        body: JSON.stringify({
          log_data: JSON.stringify(logData),
          log_type: "assesment",
          user_id: userId,
          description: "Assesment submit log",
        }),
      });
    } catch (error) {
      console.error("Error submitting log:", error);
    }
  };

  return (
    <div className={style.container}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => {
          setError(false);
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          Please enter answer..
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={submitError}
        autoHideDuration={3000}
        onClose={() => setSubmitError(false)}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          Something went wrong, please try again.
        </Alert>
      </Snackbar>

      <div className={style.assessmentSection}>
        <div
          className={style.header}
          style={{ background: trialUser ? "#FF8800" : "" }}
        >
          <div className={style.headerText}>
            {trialUser ? (
              <h5>Trial Test</h5>
            ) : (
              <>
                <span>Topic {topicNo}</span>
                <h4>{Topic.value.replace(/^Topic \d+:\s*/, "")}</h4>
              </>
            )}
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentAssessment.id ? (
              <div className={style.body}>
                <div className={style.bodyTop}>
                  <div
                    style={{ border: result ? "none" : "" }}
                    className={style.bodyLeft}
                  >
                    {!result && (
                      <div className={style.questBox}>
                        <div
                          className={`${style.questionType} ${
                            currentAssessment.question_level == "easy"
                              ? style.easy
                              : currentAssessment.question_level == "medium"
                              ? style.medium
                              : style.hard
                          }`}
                        >
                          <p className={style.questionTypeP}>
                            {currentAssessment.question_level
                              ? currentAssessment.question_level
                                  .charAt(0)
                                  .toUpperCase() +
                                currentAssessment.question_level.slice(1)
                              : ""}
                          </p>
                        </div>
                      </div>
                    )}
                    {result ? (
                      <>
                        <div className={style.resultSection}>
                          {summaryDetail?.percentage !== undefined && (
                            <>
                              {summaryDetail.percentage >= 85 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#D09B00" }}>
                                      Congratulations!{" "}
                                    </h4>
                                    <p>
                                      You’ve done really well in your Topic Test/practice exercises – keep going!
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={TrophyImage} alt="Winner" />
                                  </div>
                                </>
                              ) : summaryDetail.percentage >= 60 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#00CBF4" }}>
                                      Well Done!{" "}
                                    </h4>
                                    {/* <p>
                                      You've performed well in the test. Keep up
                                      the good work.
                                    </p> */}
                                    <p>You performed well in the test.</p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={SecondTrophyImage} alt="Winner" />
                                  </div>
                                </>
                              ) : summaryDetail.percentage >= 40 ? (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#FF8800" }}>
                                      Good effort!
                                    </h4>
                                    <p>
                                      You’re on the right track but there’s room for improvement. Try running
                                      through the lesson again or visiting the Skills Practice section before you
                                      retake your Topic Test.
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img src={ThirdTrophyImage} alt="Average" />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className={style.resultSectionHeder}>
                                    <h4 style={{ color: "#FF2443" }}>
                                      Don't give up!
                                    </h4>
                                    <p>
                                      With consistent practice, you can achieve
                                      your goals.
                                    </p>
                                  </div>
                                  <div className={style.resultSectionImage}>
                                    <img
                                      src={FourthTrophyImage}
                                      alt="Try Again"
                                    />
                                  </div>
                                </>
                              )}
                              <div className={style.resultSectionBottomContent}>
                                <p>You scored</p>
                                <h4>
                                  {summaryDetail.correct_answers}/
                                  {summaryDetail?.assessments_count || 0}
                                </h4>
                              </div>
                            </>
                          )}
                        </div>
                    {/* {Object.values(summaryDetail?.skill_set || {}) .some(skill => typeof skill?.percentage === "number") && (
                    <div className={style.progressLevel}>
                      <div className={style.strengthLevel}>
                        {Object.values(summaryDetail?.skill_set || {})
                          .filter(skill => skill.percentage > 45).length > 0 && (
                            <p className={style.progressHeader}>Your Strengths:</p>
                        )}
                    
                        {Object.values(summaryDetail?.skill_set || {})
                          .filter(skill => skill.percentage > 45)
                          .map(skill => (
                            <div key={skill.skill_id}>
                              <p className={style.skillName}>{skill.skill_name}</p>
                          
                              <div className={style.spanWithPercent}>
                                <div className={style.spanRow}>
                                  {[...Array(10)].map((_, i) => (
                                    <span
                                      key={i}
                                      className={
                                        i < Math.round((skill.percentage / 100) * 10)
                                          ? style.filledStrength
                                          : style.empty
                                      }
                                    ></span>
                                  ))}
                                </div>
                                <p className={style.percentStrength}>{Math.round(skill.percentage)}%</p>
                              </div>
                            </div>
                          ))}
                      </div>
                      <div className={style.WeakLevel}>
                        
                        {Object.values(summaryDetail?.skill_set || {})
                          .filter(skill => skill.percentage <= 45).length > 0 && (
                            <p className={style.progressHeader}>You need to improve on:</p>
                        )}
                    
                        {Object.values(summaryDetail?.skill_set || {})
                          .filter(skill => skill.percentage <= 45)
                          .map(skill => (
                            <div key={skill.skill_id}>
                              <p className={style.skillName}>{skill.skill_name}</p>
                          
                              <div className={style.spanWithPercent}>
                                <div className={style.spanRow}>
                                  {[...Array(10)].map((_, i) => (
                                    <span
                                      key={i}
                                      className={
                                        i < Math.round((skill.percentage / 100) * 10)
                                          ? style.filledWeak
                                          : style.empty
                                      }
                                    ></span>
                                  ))}
                                </div>
                                <p className={style.percentWeak}>{Math.round(skill.percentage)}%</p>
                              </div>
                            </div>
                          ))}
                      </div>
                        
                    </div>
                       )}  */}

                            
                        {!trialUser ? (
                          <div className={style.resultBottom}>
                            {/* <p>The journey to mastering grammar continues! </p> */}
                            <h4>
                              {summaryDetail?.percentage>= 40?
                              "You’re on a roll – move onto the next topic and keep adding those skills to your GrammarLocker!":"Keep practicing – go through the topic once more to improve your score"}
                            </h4>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/new/learnings", {
                                  state: {
                                    tab: "all-skills",
                                    scrollTo: "tabs"
                                  }
                                });
                              }}
                            >
                              Choose my next topic &nbsp;{">>"}
                            </button>
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <div className={style.questionSection}>
                          <div className={style.question}>
                            <div className={style.questionLeft}>
                              <span>{currentAssessment.question_no}.</span>
                            </div>
                            <div className={style.questionRight}>
                              <div className={style.questionContainer}>
                                {currentAssessment.type ===
                                "fill in the blanks" ? (
                                  <div className={style.inputWrapper}>
                                    {renderQuestionWithInputs(
                                      currentAssessment.question
                                    )}
                                  </div>
                                ) : currentAssessment.type ===
                                  "select the answers" ? (
                                  <div className={style.dropDownWrapper}>
                                    {renderQuestionWithDropdowns(
                                      currentAssessment.question,
                                      currentAssessment.options
                                    )}
                                  </div>
                                ) : (
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: currentAssessment.question,
                                    }}
                                  ></p>
                                )}
                              </div>
                              <div className={style.questionBody}>
                                {currentAssessment.type === "ordinary" ? (
                                  <div className={style.ordinaryContainer}>
                                    <div className={style.ordinarySection}>
                                      <div
                                        className={style.ordinarySectionRight}
                                      >
                                        <input
                                          spellCheck="false"
                                          autoCorrect="off"
                                          autoComplete="off"
                                          disabled={
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answered
                                          }
                                          style={{
                                            backgroundColor:
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.status === "correct"
                                                ? "#00DFC7"
                                                : assessmentData[
                                                    currentAssessment.unique_id
                                                  ]?.status === "incorrect"
                                                ? "#FF7C8E"
                                                : "transparent",
                                          }}
                                          onChange={(e) => {
                                            const uniqueId =
                                              currentAssessment.unique_id;
                                            setAssessmentData((prev) => ({
                                              ...prev,
                                              [uniqueId]: {
                                                ...prev[uniqueId],
                                                answers: [e.target.value],
                                              },
                                            }));
                                          }}
                                          value={
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers[0] || ""
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : currentAssessment.type ===
                                  "multiple choices" ? (
                                  <div
                                    className={style.multipleChoiceContainer}
                                  >
                                    {currentAssessment.options
                                      ?.filter(
                                        (option) =>
                                          String(option)
                                            .replace(/<[^>]*>/g, "")
                                            .replace(/&nbsp;/gi, " ")
                                            .trim() !== ""
                                      )
                                      .map((option, index) => {
                                        const selectedIndexes =
                                          selectedOptions[
                                            currentAssessment.unique_id
                                          ] || [];
                                        const isSelected =
                                          selectedIndexes.includes(index);
                                        const status =
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.status;

                                        // Get actual_ans and answers
                                        const actualAnsList =
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.actual_ans || [];
                                        const userAnswers =
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers || [];

                                        // Check if this option is in both actual_ans and user's answer
                                        const normalizedOption = option.trim();
                                          const isBlue =
                                            actualAnsList.some(
                                              (ans) => ans.trim() === normalizedOption
                                            ) &&
                                            userAnswers.some(
                                              (ans) => ans.trim() === normalizedOption
                                            );
                                        let optionClass = "";
                                        if (isBlue) {
                                          optionClass = style.blueHighlight;
                                        } else if (isSelected) {
                                          optionClass =
                                            status === "correct"
                                              ? style.correct
                                              : status === "incorrect"
                                              ? style.incorrect
                                              : style.selected;
                                        } else {
                                          optionClass = style.unselected;
                                        }

                                        return (
                                          <div
                                            key={index}
                                            onClick={() => {
                                              if (
                                                assessmentData[
                                                  currentAssessment.unique_id
                                                ]?.answered !== true
                                              ) {
                                                handleOptionClick(
                                                  option,
                                                  index
                                                );
                                              }
                                            }}
                                            className={`${style.multipleChoiceAnswer} ${optionClass}`}
                                          >
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: String(option)
                                                  .replace(/<p>/gi, "")
                                                  .replace(/<\/p>/gi, "")
                                                  .replace(/&nbsp;/g, " "),
                                              }}
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                ) : currentAssessment.type ===
                                  "Match the following" ? (
                                  <div
                                    className={style.matchFollowingContainer}
                                  >
                                    <DragDropContext
                                      onDragEnd={handleOnDragEnd}
                                    >
                                      {Array.from({
                                        length: Math.max(
                                          (
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers?.left || []
                                          ).length,
                                          (
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers?.right || []
                                          ).length
                                        ),
                                      }).map((_, i) => {
                                        const leftData =
                                          (assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers?.left || [])[i] || "";
                                        const rightData =
                                          (assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers?.right || [])[i] || "";

                                        const matchValue =
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.match?.[i];
                                        let cardClassName;
                                        if (matchValue === "1") {
                                          cardClassName = style.correctCard;
                                        } else if (matchValue === "0") {
                                          cardClassName = style.errorCard;
                                        } else {
                                          cardClassName = style.defaultCard;
                                        }

                                        return (
                                          <React.Fragment key={i}>
                                            <Droppable
                                              droppableId={`left-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingLeft
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {leftData && (
                                                    <Draggable
                                                      draggableId={`left-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentAssessment.draggable ===
                                                          "right" ||
                                                        assessmentData[
                                                          currentAssessment
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided, snapshot) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${
                                                            style.matchFollowingCard
                                                          } ${cardClassName} ${
                                                            snapshot.isDragging
                                                              ? style.matchFollowingCardDragging
                                                              : ""
                                                          }`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: leftData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>

                                            <Droppable
                                              droppableId={`right-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingRight
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {rightData && (
                                                    <Draggable
                                                      draggableId={`right-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentAssessment.draggable ===
                                                          "left" ||
                                                        assessmentData[
                                                          currentAssessment
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided, snapshot) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${
                                                            style.matchFollowingCard
                                                          } ${cardClassName} ${
                                                            snapshot.isDragging
                                                              ? style.matchFollowingCardDragging
                                                              : ""
                                                          }`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                          </React.Fragment>
                                        );
                                      })}
                                    </DragDropContext>
                                  </div>
                                ) : currentAssessment.type ===
                                  "Match the following with image" ? (
                                  <div
                                    className={style.matchFollowingContainer}
                                  >
                                    <DragDropContext
                                      onDragEnd={handleOnDragEnd}
                                    >
                                      {Array.from({
                                        length: Math.max(
                                          (
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers?.left || []
                                          ).length,
                                          (
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers?.right || []
                                          ).length
                                        ),
                                      }).map((_, i) => {
                                        const leftData =
                                          (assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers?.left || [])[i] || "";
                                        const rightData =
                                          (assessmentData[
                                            currentAssessment.unique_id
                                          ]?.answers?.right || [])[i] || "";

                                        const matchValue =
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.match?.[i];
                                        let cardClassName;
                                        if (matchValue === "1") {
                                          cardClassName = style.correctCard;
                                        } else if (matchValue === "0") {
                                          cardClassName = style.errorCard;
                                        } else {
                                          cardClassName = style.defaultCard;
                                        }

                                        return (
                                          <React.Fragment key={i}>
                                            <Droppable
                                              droppableId={`left-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingLeft
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {leftData && (
                                                    <Draggable
                                                      draggableId={`left-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentAssessment.draggable ===
                                                          "right" ||
                                                        assessmentData[
                                                          currentAssessment
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided, snapshot) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${
                                                            style.matchFollowingImageCard
                                                          } ${cardClassName} ${
                                                            snapshot.isDragging
                                                              ? style.matchFollowingImageCardDragging
                                                              : ""
                                                          }`}
                                                        >
                                                          <img
                                                            src={leftData}
                                                            alt={`Option ${
                                                              i + 1
                                                            }`}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>

                                            <Droppable
                                              droppableId={`right-${i}`}
                                            >
                                              {(provided) => (
                                                <div
                                                  className={
                                                    style.matchFollowingRight
                                                  }
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {rightData && (
                                                    <Draggable
                                                      draggableId={`right-${i}`}
                                                      index={i}
                                                      isDragDisabled={
                                                        currentAssessment.draggable ===
                                                          "left" ||
                                                        assessmentData[
                                                          currentAssessment
                                                            .unique_id
                                                        ]?.answered
                                                      }
                                                    >
                                                      {(provided, snapshot) => (
                                                        <div
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          className={`${
                                                            style.matchFollowingCard
                                                          } ${cardClassName} ${
                                                            snapshot.isDragging
                                                              ? style.matchFollowingCardDragging
                                                              : ""
                                                          }`}
                                                        >
                                                          <p
                                                            dangerouslySetInnerHTML={{
                                                              __html: rightData,
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                    </Draggable>
                                                  )}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                          </React.Fragment>
                                        );
                                      })}
                                    </DragDropContext>
                                  </div>
                                ) : currentAssessment.type === "Rearrange" ? (
                                  <DndContext
                                    collisionDetection={closestCenter}
                                    onDragStart={() => setIsDragging(true)}
                                    onDragEnd={handleArrangeDragEnd}
                                  >
                                    <SortableContext
                                      items={assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers.map(
                                        (_, index) => `option-${index}`
                                      )}
                                      strategy={rectSortingStrategy}
                                      disabled={
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answered
                                      }
                                    >
                                      <div
                                        className={`${style.reArrangeContainer} ${
                                          currentAssessment?.sentence_type
                                            ? style.reArrangeContainerSentence
                                            : ""
                                        } ${isDragging ? style.dragging : ""}`}
                                      >
                                        {assessmentData[
                                          currentAssessment.unique_id
                                        ]?.answers.map((option, index) => (
                                          <SortableItem
                                            key={`option-${index}`}
                                            id={`option-${index}`}
                                            option={option}
                                            index={index}
                                            incorrectIndexes={assessmentData[currentAssessment.unique_id]?.incorrect_index}
                                            isSentenceType={currentAssessment?.sentence_type}
                                          />
                                        ))}
                                        {currentAssessment?.append_period && (
                                          <p>.</p>
                                        )}
                                      </div>
                                    </SortableContext>

                                    <div className={style.statusMark}>
                                      {assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered &&
                                        (assessmentData[
                                          currentAssessment.unique_id
                                        ]?.status === "correct" ? (
                                          <FaCheck
                                            style={{ color: "#00DFC7" }}
                                          />
                                        ) : (
                                          <IoMdClose
                                            style={{ color: "#FF7C8E" }}
                                          />
                                        ))}
                                    </div>
                                  </DndContext>
                                ) : currentAssessment.type ===
                                  "cross word puzzle" ? (
                                  <div className={style.crossWordContainer}>
                                    <div className={style.crossWordPuzzle}>
                                      {assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answers.map((row, rowIndex) => (
                                        <div
                                          key={rowIndex}
                                          className={style.row}
                                        >
                                          {row.map((cell, colIndex) => (
                                            <div
                                              key={`${rowIndex}-${colIndex}`}
                                              className={style.cellContainer}
                                            >
                                              {!cell.disabled && (
                                                <input
                                                  autoCorrect="off"
                                                  autoComplete="off"
                                                  spellCheck="false"
                                                  type="text"
                                                  maxLength="1"
                                                  className={style.activeInput}
                                                  value={cell.value}
                                                  onChange={(e) =>
                                                    handleCellValueChange(
                                                      rowIndex,
                                                      colIndex,
                                                      e.target.value,
                                                      cell.clueID,
                                                      cell.clueNumber
                                                    )
                                                  }
                                                  disabled={cell.disabled}
                                                  ref={(el) => {
                                                    if (el) {
                                                      if (
                                                        !inputRefs.current[
                                                          currentAssessment
                                                            .unique_id
                                                        ]
                                                      ) {
                                                        inputRefs.current[
                                                          currentAssessment.unique_id
                                                        ] = [];
                                                      }
                                                      inputRefs.current[
                                                        currentAssessment.unique_id
                                                      ][
                                                        rowIndex *
                                                          (assessmentData[
                                                            currentAssessment
                                                              .unique_id
                                                          ]?.answers[0]
                                                            ?.length || 0) +
                                                          colIndex
                                                      ] = el;
                                                    }
                                                  }}
                                                />
                                              )}
                                              {cell.clueNumber && (
                                                <div
                                                  className={style.clueNumber}
                                                >
                                                  {cell.clueNumber}
                                                </div>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                    <div className={style.PuzzleQuestion}>
                                      <div className={style.QuestionAcross}>
                                        <h4>Across</h4>
                                        {assessmentData[
                                          currentAssessment.unique_id
                                        ]?.cluesAcross.map((clueObj, index) => (
                                          <div
                                            key={index}
                                            className={
                                              style.QuestionAcrossInputContainer
                                            }
                                          >
                                            <span>
                                              {clueObj.number}.{clueObj.clue}{" "}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                      <div className={style.QuestionDown}>
                                        <h4>Down</h4>
                                        {assessmentData[
                                          currentAssessment.unique_id
                                        ]?.cluesDown.map((clueObj, index) => (
                                          <div
                                            key={index}
                                            className={
                                              style.QuestionDownInputContainer
                                            }
                                          >
                                            <span>
                                              {clueObj.number}.{clueObj.clue}{" "}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                ) : currentAssessment.type === "Rewrite" ? (
                                  <div className={style.ordinaryContainer}>
                                    <div className={style.ordinarySection}>
                                      <div
                                        className={style.rewriteSectionRight}
                                      >
                                        <textarea
                                          className={style.textareaStyle}
                                          spellCheck="false"
                                          disabled={
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answered
                                          }
                                          rows={1}
                                          onChange={(e) => {
                                            const uniqueId =
                                              currentAssessment.unique_id;
                                            const sanitizedValue =
                                              e.target.value
                                                .replace(/‘|’/g, "'")
                                                .replace(/“|”/g, '"');
                                            setAssessmentData((prev) => ({
                                              ...prev,
                                              [uniqueId]: {
                                                ...prev[uniqueId],
                                                answers: [sanitizedValue],
                                              },
                                            }));
                                          }}
                                          value={
                                            assessmentData[
                                              currentAssessment.unique_id
                                            ]?.answers[0] || ""
                                          }
                                          onFocus={(e) =>
                                            (e.target.style.border =
                                              "1px solid #FF7A00")
                                          }
                                          onBlur={(e) =>
                                            (e.target.style.border =
                                              "1px solid #898890")
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                ) : currentAssessment.type === "highlight" ? (
                                  <ReactQuill
                                    disabled={
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                    }
                                    ref={quillRef}
                                    value={
                                      assessmentData[
                                        currentAssessment?.unique_id
                                      ]?.highlightContent || ""
                                    }
                                    onChange={handleQuillChange}
                                    onChangeSelection={handleSelectionChange}
                                    modules={{
                                      toolbar: false,
                                    }}
                                    style={{
                                      width: "100%",
                                      maxHeight: "200px",
                                      border: "none !important",
                                      pointerEvents: assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "auto", // Disable mouse interactions
                                      userSelect: assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "text", // Disable text selection
                                    }}
                                    readOnly={true}
                                    className={style.customQuill}
                                  />
                                ) : currentAssessment.type ===
                                  "highlight_multiple" ? (
                                  (() => {
                                    const uniqueId =
                                      currentAssessment.unique_id;
                                    const currentData =
                                      assessmentData[uniqueId] || {};
                                    const correctIndexes =
                                      normalizeHighlightMultipleCorrectIndex(
                                        currentData.correct_index || []
                                      );
                                    const contentToShow =
                                      currentData.answered &&
                                      correctIndexes.length > 0
                                        ? highlightRangesInHtml(
                                            currentData
                                              .highlightMultipleContent || "",
                                            correctIndexes,
                                            "rgb(0, 223, 199)"
                                          )
                                        : currentData
                                            .highlightMultipleContent || "";
                                    return (
                                  <ReactQuill
                                    disabled={
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                    }
                                    ref={quillRef}
                                    value={
                                      contentToShow
                                    }
                                    onChange={
                                      handleHighlightMultipleQuillChange
                                    }
                                    onChangeSelection={
                                      handleMultipleSelectionChange
                                    }
                                    modules={{
                                      toolbar: false,
                                    }}
                                    style={{
                                      width: "100%",
                                      maxHeight: "200px",
                                      border: "none !important",
                                      pointerEvents: assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "auto", // Disable mouse interactions
                                      userSelect: assessmentData[
                                        currentAssessment.unique_id
                                      ]?.answered
                                        ? "none"
                                        : "text", // Disable text selection
                                    }}
                                    readOnly={true}
                                    className={style.customQuill}
                                  />
                                    );
                                  })()
                                ) : currentAssessment.type ===
                                  "Drag and Drop" ? (
                                  (() => {
                                    const dragDropId =
                                      currentAssessment.unique_id;
                                    const dragDropAnswered =
                                      assessmentData[dragDropId]?.answered;
                                    const dragDropIncorrectIndexes =
                                      assessmentData[dragDropId]
                                        ?.incorrect_index || [];

                                    return (
                                  <div className={style.dragContainer}>
                                    <div
                                      className={`${style.dragOptionContainer} ${
                                        currentAssessment?.sentence_type
                                          ? style.dragOptionContainerSentence
                                          : ""
                                      }`}
                                    >
                                      {currentAssessment.options
                                        ?.filter(
                                          (option) => option.trim() !== ""
                                        )
                                        .map((option, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className={`${style.dragCard} ${
                                                currentAssessment?.sentence_type
                                                  ? style.dragCardSentence
                                                  : ""
                                              }`}
                                              draggable={!dragDropAnswered}
                                              onDragStart={(event) =>
                                                !dragDropAnswered &&
                                                handleDragStart(event, option)
                                              }
                                            >
                                              <p dangerouslySetInnerHTML={{ __html: option }}></p>
                                            </div>
                                          );
                                        })}
                                    </div>
                                    <div className={style.dragTable}>
                                      <table className={style.table}>
                                        <thead>
                                          <tr>
                                            {assessmentData[
                                              dragDropId
                                            ]?.answers.map((col, colIndex) => (
                                              <th
                                                key={colIndex}
                                                className={style.tableHeader}
                                              >
                                                {col.header || " "}
                                              </th>
                                            ))}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {renderDragDropTableBody({
                                            columns:
                                              assessmentData[dragDropId]
                                                ?.answers,
                                            answered: dragDropAnswered,
                                            incorrectIndexes:
                                              dragDropIncorrectIndexes,
                                            sentenceType:
                                              currentAssessment?.sentence_type,
                                            onDragOver: handleDragOver,
                                            onDrop: handleDrop,
                                            onDelete: handleDeleteDroppedCell,
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                    );
                                  })()
                                ) : currentAssessment.type === "drag and drop_v2" ? (
                                  (() => {
                                    const dragDropId = currentAssessment.unique_id;
                                    const dragDropAnswered = assessmentData[dragDropId]?.answered;
                                    const dragDropIncorrectIndexes = assessmentData[dragDropId]?.incorrect_index || [];
                                    const answers = assessmentData[dragDropId]?.answers || [];
                                    let sentences = [];
                                    if (currentAssessment.left && currentAssessment.left.length > 0) {
                                      sentences = currentAssessment.left;
                                    } else if (currentAssessment.paragraphs && currentAssessment.paragraphs.length > 0) {
                                      sentences = currentAssessment.paragraphs;
                                    } else if (currentAssessment.options) {
                                      if (Array.isArray(currentAssessment.options)) {
                                        sentences = currentAssessment.options;
                                      } else if (typeof currentAssessment.options === "string") {
                                        sentences = currentAssessment.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                      }
                                    }
                                    const placedWords = answers.flatMap((col) => col.values || []).filter(Boolean);

                                    return (
                                      <div className={style.dragContainer}>
                                        <div className={style.sentencesContainerV2}>
                                          {sentences.map((sentence, sIdx) => {
                                            const parts = parseSentence(sentence);
                                            return (
                                              <p key={sIdx} className={style.sentenceTextV2}>
                                                {parts.map((part, pIdx) => {
                                                  if (part.isDraggable) {
                                                    const isPlaced = placedWords.some(
                                                      (pw) => pw.trim().toLowerCase() === part.word.trim().toLowerCase()
                                                    );
                                                    return (
                                                      <span
                                                        key={pIdx}
                                                        className={isPlaced ? style.draggableWordPlaced : style.draggableWord}
                                                        draggable={!dragDropAnswered && !isPlaced}
                                                        onDragStart={(event) => {
                                                          if (!dragDropAnswered && !isPlaced) {
                                                            handleDragStart(event, part.word);
                                                          }
                                                        }}
                                                      >
                                                        {part.word}
                                                      </span>
                                                    );
                                                  }
                                                  return <span key={pIdx} dangerouslySetInnerHTML={{ __html: part.text }} />;
                                                })}
                                              </p>
                                            );
                                          })}
                                        </div>

                                        <div className={style.dragTable}>
                                          <table className={style.dragTableV2}>
                                            <thead>
                                              <tr>
                                                {answers.map((col, colIndex) => (
                                                  <th
                                                    key={colIndex}
                                                    className={style.dragTableHeaderV2}
                                                  >
                                                    {col.header || " "}
                                                  </th>
                                                ))}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {renderDragDropTableBodyV2({
                                                columns: answers,
                                                answered: dragDropAnswered,
                                                incorrectIndexes: dragDropIncorrectIndexes,
                                                onDelete: (colIdx, rowIdx) =>
                                                  handleDeleteDroppedCellV2(colIdx, rowIdx, dragDropId),
                                                uniqueId: dragDropId,
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    );
                                  })()
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className={style.questionButtonSection}>
                                <div className={style.questionButtonLeft}>
                                  {/* {currentAssessment.type === "highlight" &&(
                                    <span>
                                      *Select the text you want to highlight.
                                    </span>
                                  )}
                                  {currentAssessment.type === "highlight_multiple" &&(
                                    <span>
                                      *Select all the text you think is correct.
                                    </span>
                                  )} */}
                                  {currentAssessment.type === "Match the following" &&(
                                    <span>
                                      *Drag the boxes on the right to drop them next to
                                      the correct match on the left.
                                    </span>
                                  )}
                                  {currentAssessment.type === "Drag and Drop" && (
                                    <span>
                                      *Drag each item and drop it into the correct position.
                                    </span>
                                  )}
                                  {currentAssessment.type === "drag and drop_v2" && (
                                    <span>
                                      *Drag each underlined word and drop it into the correct category box.
                                    </span>
                                  )}
                                </div>
                                <div className={style.questionButtonRight}>
                                  {assessmentData[currentAssessment.unique_id]
                                    ?.answered || submitLoading ? (
                                    ""
                                  ) : (
                                    <div className={style.btnGrp}>
                                      <button
                                        className={style.skipButtonP}
                                        onClick={() => {
                                          if (
                                            currentIndex ===
                                            assessment.length - 1
                                          ) {
                                            setFinishPopup(true);
                                          } else {
                                            handleSkip();
                                          }
                                        }}
                                      >
                                        <p>Skip</p>
                                      </button>

                                      {currentAssessment?.hint && (
                                        <div className={style.hintContainer}>
                                          {!showHint ? (
                                            <img
                                              src={HintImage}
                                              alt="hint"
                                              className={style.hintImage}
                                              onClick={() => {
                                                setShowHint(true);
                                                setHintDialog(true);
                                              }}
                                            />
                                          ) : (
                                            <div
                                              className={
                                                style.hintActiveContainer
                                              }
                                              ref={hintRef}
                                            >
                                              <img
                                                src={HintImage2}
                                                alt="hint active"
                                                className={style.hintImage2}
                                                onClick={() => {
                                                  setShowHint(false);
                                                  setHintDialog(false);
                                                }}
                                              />
                                              {hintDialog && (
                                                <div
                                                  className={style.hintDialog}
                                                >
                                                  <div
                                                    className={
                                                      style.hintDialogContent
                                                    }
                                                  >
                                                    {currentAssessment?.hint}
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  {assessmentData[currentAssessment.unique_id]
                                    ?.answered ? (
                                    <>
                                      {currentIndex !==
                                      assessment.length - 1 ? (
                                        <button
                                          onClick={() => handleNext()}
                                          disabled={
                                            currentIndex ===
                                            assessment.length - 1
                                          }
                                          style={{ background: "#00CBF480" }}
                                        >
                                          Next
                                        </button>
                                      ) : null}
                                    </>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        const uniqueId =
                                          currentAssessment.unique_id;
                                        const answers =
                                          assessmentData[uniqueId]?.answers ||
                                          [];
                                        const isAlreadyAnswered =
                                          assessmentData[uniqueId]?.answered;

                                        handleSubmitLog(
                                          currentAssessment.id,
                                          currentAssessment.type,
                                          {
                                            validateClicked,
                                            isAlreadyAnswered,
                                            hasAnswers: answers.length > 0,
                                          }
                                        );

                                        setSubmitLoading(true);

                                        if (
                                          validateClicked ||
                                          isAlreadyAnswered
                                        ) {
                                          return;
                                        }

                                        if (
                                          currentAssessment.type ===
                                            "Match the following" ||
                                          currentAssessment.type ===
                                            "Match the following with image"
                                        ) {
                                          const rightOrder =
                                            assessmentData[uniqueId]
                                              ?.rightOrder ||
                                            (answers?.right || []).map(
                                              (_, i) => i
                                            );

                                          // Track by original position, not text value
                                          // (duplicate values can look unchanged after a real swap)
                                          const areRightAnswersSame =
                                            rightOrder.length === 0 ||
                                            rightOrder.every(
                                              (pos, index) => pos === index
                                            );

                                          if (areRightAnswersSame) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            assessmentAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentAssessment.type === "Rearrange"
                                        ) {
                                          const options =
                                            currentAssessment.options.filter(
                                              (op) => op.trim() !== ""
                                            ) || [];
                                          const areAnswersSame =
                                            options.length === answers.length &&
                                            options.every(
                                              (value, index) =>
                                                value === answers[index]
                                            );
                                          if (areAnswersSame) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            assessmentAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentAssessment.type === "highlight"
                                        ) {
                                          if (
                                            assessmentData[uniqueId]
                                              ?.lastSelectedText === ""
                                          ) {
                                            setError(true);
                                            setSubmitLoading(false);
                                          } else {
                                            assessmentAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentAssessment.type ===
                                          "highlight_multiple"
                                        ) {
                                          const highlightRanges =
                                            assessmentData[uniqueId]
                                              ?.highlightMultipleRange || [];
                                          if (highlightRanges.length === 0) {
                                            setError(true);
                                            setSubmitLoading(false);
                                          } else {
                                            assessmentAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (
                                          currentAssessment.type ===
                                          "select the answers"
                                        ) {
                                          const unansweredDropdownIds =
                                            currentAssessment.options
                                              .map((option) => option.id)
                                              .filter(
                                                (dropdownId) =>
                                                  !(
                                                    answers[dropdownId] &&
                                                    answers[dropdownId].trim() !==
                                                      ""
                                                  )
                                              );

                                          if (unansweredDropdownIds.length > 0) {
                                            setUnansweredSelectDropdowns(
                                              unansweredDropdownIds
                                            );
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          }

                                          setUnansweredSelectDropdowns([]);
                                          assessmentAnswer();
                                          setValidateClicked(true);
                                        } else if (
                                          (currentAssessment.type === "Drag and Drop" || currentAssessment.type === "drag and drop_v2") &&
                                          true
                                        ) {
                                          const hasAtLeastOneAnswer =
                                            answers.some((col) =>
                                              col.values.some(
                                                (value) => value.trim() !== ""
                                              )
                                            );

                                          if (!hasAtLeastOneAnswer) {
                                            setError(true);
                                            setSubmitLoading(false);
                                            return;
                                          } else {
                                            assessmentAnswer();
                                            setValidateClicked(true);
                                            setSubmitLoading(true);
                                          }
                                        } else if (answers.length > 0) {
                                          assessmentAnswer();
                                          setValidateClicked(true);
                                        } else {
                                          setError(true);
                                          setSubmitLoading(false);
                                        }
                                      }}
                                    >
                                      
                                        Submit
                                     
                                    </button>
                                  )}
                                </div>
                              </div>
                              {assessmentData[currentAssessment.unique_id]
                                ?.answered ? (
                                <div className={style.explanationSection}>
                                  <div className={style.resultText}>
                                    <p
                                      style={{
                                        color:
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.status === "correct"
                                            ? "#00DFC7"
                                            : "#FF2443",
                                      }}
                                    >
                                      {assessmentData[
                                        currentAssessment.unique_id
                                      ]?.resultMessage ||
                                        (assessmentData[
                                          currentAssessment.unique_id
                                        ]?.status === "correct"
                                          ? CORRECT_MESSAGES[0]
                                          : INCORRECT_MESSAGES[0])}
                                        
                                    </p>
                                  </div>
                                  {assessmentData[currentAssessment.unique_id]
                                    ?.answered &&
                                  assessmentData[currentAssessment.unique_id]
                                    ?.status === "incorrect" &&
                                  assessmentData[currentAssessment.unique_id]
                                    ?.actual_ans.length > 0 ? (
                                    <>
                                      <div
                                        className={style.correctAnswerHeading}
                                      >
                                        <p>Answer:</p>
                                      </div>
                                      {assessmentData[
                                        currentAssessment.unique_id
                                      ]?.question_type ===
                                        "Match the following" &&
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.left &&
                                      assessmentData[
                                        currentAssessment.unique_id
                                      ]?.left.length > 0 ? (
                                        <div className={style.answerBodyMatch}>
                                          {Array.from({
                                            length: Math.max(
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.left.length,
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.actual_ans.length
                                            ),
                                          }).map((_, index) => {
                                            const leftItem =
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.left[index] || "";
                                            const rightItem =
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.actual_ans[index] || "";

                                            return (
                                              <div
                                                key={index}
                                                className={style.matchRow}
                                              >
                                                {leftItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardLeft
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: leftItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                                {rightItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardRight
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: rightItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type ===
                                        "fill in the blanks" ? (
                                        <div>
                                        {assessmentData[currentAssessment.unique_id]?.actual_ans?.length > 0 ? (
                                          renderFillBlankQuestionWithAnswer(
                                            currentAssessment.question,
                                            assessmentData[currentAssessment.unique_id]?.actual_ans
                                          )    
                                           ): (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type ===
                                          "Match the following with image" &&
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.left &&
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.left.length > 0 ? (
                                        <div className={style.answerBodyMatch}>
                                          {Array.from({
                                            length: Math.max(
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.left.length,
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.actual_ans.length
                                            ),
                                          }).map((_, index) => {
                                            const leftItem =
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.left[index] || "";
                                            const rightItem =
                                              assessmentData[
                                                currentAssessment.unique_id
                                              ]?.actual_ans[index] || "";
                                            return (
                                              <div
                                                key={index}
                                                className={style.matchRow}
                                              >
                                                {leftItem && (
                                                  <div
                                                    className={
                                                      style.matchRowImageCard
                                                    }
                                                  >
                                                    <img
                                                      src={leftItem}
                                                      alt={`Answer ${
                                                        index + 1
                                                      }`}
                                                      width="200px"
                                                    />
                                                  </div>
                                                )}
                                                {rightItem && (
                                                  <div
                                                    className={
                                                      style.matchRowCardRight
                                                    }
                                                  >
                                                    <p
                                                      dangerouslySetInnerHTML={{
                                                        __html: rightItem,
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type ===
                                        "select the answers" ? (
                                        <div>
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.actual_ans &&
                                          assessmentData[
                                            currentAssessment.unique_id
                                          ]?.actual_ans.length > 0 ? (
                                            renderSelectAnswersQuestionWithAnswer(
                                              currentAssessment.question,
                                              assessmentData[currentAssessment.unique_id]?.actual_ans
                                            )
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type === "Rearrange" ? (
                                        <div>
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.actual_ans.length > 0 ? (
                                            <div
                                              className={`${style.reArrangeContainer} ${
                                                currentAssessment?.sentence_type
                                                  ? style.reArrangeContainerSentence
                                                  : ""
                                              }`}
                                            >
                                              {assessmentData[
                                                currentAssessment.unique_id
                                              ]?.actual_ans[0] &&
                                                Object.entries(
                                                  assessmentData[
                                                    currentAssessment.unique_id
                                                  ]?.actual_ans[0]
                                                ).map(([key, value]) => (
                                                  <p
                                                    className={`${style.reArrangeAnswerCard} ${
                                                      currentAssessment?.sentence_type
                                                        ? style.reArrangeAnswerCardSentence
                                                        : ""
                                                    }`}
                                                    key={key}
                                                    dangerouslySetInnerHTML={{
                                                      __html: String(value ?? "")
                                                        .replace(/<p>/gi, "")
                                                        .replace(/<\/p>/gi, "")
                                                        .replace(/&nbsp;/g, " "),
                                                    }}
                                                  />
                                                ))}
                                                {currentAssessment?.append_period && (
                                                <p>.</p>
                                                )}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type ===
                                        "cross word puzzle" ? (
                                        <div>
                                          <p
                                            style={{
                                              textDecoration: "underLine",
                                            }}
                                          >
                                            Across
                                          </p>
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.left.length > 0 ? (
                                            <div>
                                              {assessmentData[
                                                currentAssessment.unique_id
                                              ]?.left.map((value, i) => (
                                                <p key={i}>
                                                  {value.number}.{value.answer}
                                                </p>
                                              ))}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                          <p
                                            style={{
                                              textDecoration: "underLine",
                                            }}
                                          >
                                            Down
                                          </p>
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.right.length > 0 ? (
                                            <div>
                                              {assessmentData[
                                                currentAssessment.unique_id
                                              ]?.right.map((value, i) => (
                                                <p key={i}>
                                                  {value.number}.{value.answer}
                                                </p>
                                              ))}
                                            </div>
                                          ) : (
                                            <p>No correct answers available</p>
                                          )}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type === "highlight" ||
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type === "highlight_multiple" ? (
                                        <div>
                                          {renderHighlightQuestionWithAnswer(
                                            currentAssessment.options ||
                                              currentAssessment.question ||
                                              "",
                                            assessmentData[currentAssessment.unique_id]
                                              ?.actual_ans || []
                                          )}
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type === "Drag and Drop" ? (
                                        <div className={style.dragContainer}>
                                          <div className={style.dragTable}>
                                            <table className={style.table}>
                                              <thead>
                                                <tr>
                                                  {assessmentData[
                                                    currentAssessment.unique_id
                                                  ]?.actual_ans.map(
                                                    (col, colIndex) => (
                                                      <th
                                                        key={colIndex}
                                                        className={
                                                          style.tableHeader
                                                        }
                                                      >
                                                        {col.header || " "}
                                                      </th>
                                                    )
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {renderDragDropTableBody({
                                                  columns:
                                                    assessmentData[
                                                      currentAssessment
                                                        .unique_id
                                                    ]?.actual_ans,
                                                  answered: false,
                                                  incorrectIndexes: [],
                                                  sentenceType:
                                                    currentAssessment?.sentence_type,
                                                })}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.question_type === "drag and drop_v2" ? (
                                        (() => {
                                          let sentences = [];
                                          if (currentAssessment.left && currentAssessment.left.length > 0) {
                                            sentences = currentAssessment.left;
                                          } else if (currentAssessment.paragraphs && currentAssessment.paragraphs.length > 0) {
                                            sentences = currentAssessment.paragraphs;
                                          } else if (currentAssessment.options) {
                                            if (Array.isArray(currentAssessment.options)) {
                                              sentences = currentAssessment.options;
                                            } else if (typeof currentAssessment.options === "string") {
                                              sentences = currentAssessment.options.split(/<br\s*\/?>|\n/gi).filter(Boolean);
                                            }
                                          }
                                          return (
                                            <div className={style.dragContainer}>
                                      
                                              <div className={style.dragTable}>
                                                <table className={style.dragTableV2}>
                                                  <thead>
                                                    <tr>
                                                      {assessmentData[
                                                        currentAssessment.unique_id
                                                      ]?.actual_ans.map(
                                                        (col, colIndex) => (
                                                          <th
                                                            key={colIndex}
                                                            className={
                                                              style.dragTableHeaderV2
                                                            }
                                                          >
                                                            {col.header || " "}
                                                          </th>
                                                        )
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {renderDragDropTableBodyV2({
                                                      columns:
                                                        assessmentData[
                                                          currentAssessment
                                                            .unique_id
                                                        ]?.actual_ans,
                                                      answered: false,
                                                      incorrectIndexes: [],
                                                      uniqueId: currentAssessment.unique_id,
                                                    })}
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          );
                                        })()
                                      ) : assessmentData[
                                          currentAssessment.unique_id
                                        ]?.actual_ans &&
                                        assessmentData[
                                          currentAssessment.unique_id
                                        ]?.actual_ans.length > 0 ? (
                                        <div>
                                          {assessmentData[
                                            currentAssessment.unique_id
                                          ]?.actual_ans.map(
                                            (answer, answerIndex) => (
                                              <p
                                                key={answerIndex}
                                                dangerouslySetInnerHTML={{
                                                  __html: String(answer ?? "")
                                                    .replace(/<p>/gi, "")
                                                    .replace(/<\/p>/gi, "")
                                                    .replace(/&nbsp;/g, " "),
                                                }}
                                              />
                                            )
                                          )}
                                        </div>
                                      ) : (
                                        <p>No answers available</p>
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}

                                  {assessmentData[currentAssessment.unique_id]
                                    ?.answered &&
                                  assessmentData[
                                    currentAssessment.unique_id
                                  ]?.explanations?.trim() &&
                                  assessmentData[
                                    currentAssessment.unique_id
                                  ]?.explanations
                                    .replace(/<[^>]*>/g, "")
                                    .trim() ? (
                                    <>
                                      <div className={style.explanationHeading}>
                                        <p>Explanation:</p>
                                      </div>
                                      <div className={style.explanationText}>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              explanationWithDefaultImageSize,
                                          }}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className={style.bodyRight}>
                    {result ? (
                      <div className={style.summeryContainer}>
                        <div className={style.summeryTopContent}>
                          <div className={style.roundGraph}>
                            <Doughnut
                              data={{
                                labels: ["Completed", "Remaining"],
                                datasets: [
                                  {
                                    data: [
                                      summaryDetail?.percentage || 0,
                                      100 - (summaryDetail?.percentage || 0),
                                    ],

                                    backgroundColor: ["#03CD09", "#3E3D4212"],
                                    borderWidth: 0,
                                  },
                                ],
                              }}
                              options={{
                                cutout: "85%",
                                plugins: {
                                  legend: {
                                    display: false,
                                  },
                                },
                              }}
                            />
                            <div
                              className={style.graphText}
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                pointerEvents: "none",
                              }}
                            >
                              {Math.round(summaryDetail?.percentage || 0)}%
                            </div>
                          </div>
                          <div className={style.summeryTopText}>
                            <p>Your score</p>
                          </div>
                        </div>
                        <div className={style.summeryBottomContent}>
                          <div className={style.summeryBottomData}>
                            <div className={style.summeryBottomDataLeft}>
                              <span style={{ background: "#00DFC7" }}>
                                {summaryDetail?.correct_answers || 0}
                              </span>
                            </div>
                            <div className={style.summeryBottomDataRight}>
                              <p>Correct answers</p>
                            </div>
                          </div>
                          <div className={style.summeryBottomData}>
                            <div className={style.summeryBottomDataLeft}>
                              <span style={{ background: "#FF2443" }}>
                                {summaryDetail?.wrong_answers || 0}{" "}
                              </span>
                            </div>
                            <div className={style.summeryBottomDataRight}>
                              <p>Wrong answers</p>
                            </div>
                          </div>
                          <div className={style.summeryBottomData}>
                            <div className={style.summeryBottomDataLeft}>
                              <span style={{ background: "#FFBE00" }}>
                                {summaryDetail?.assessments_count -
                                  (summaryDetail?.correct_answers +
                                    summaryDetail?.wrong_answers)}
                              </span>
                            </div>
                            <div className={style.summeryBottomDataRight}>
                              <p>Skipped questions</p>
                            </div>
                          </div>
                          <div className={style.summeryBottomData}>
                            <div className={style.summeryBottomDataLeft}>
                              <span style={{ background: "#595BDB" }}>
                                {summaryDetail?.assessments_count || 0}{" "}
                              </span>
                            </div>
                            <div className={style.summeryBottomDataRight}>
                              <p>No. of questions</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className={style.markContainer}>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Total mark</p>
                            </div>
                            <div
                              style={{ marginBottom: "8px" }}
                              className={style.markDataRight}
                            >
                              <p>
                                <span>{correctCount}</span>/{totalCount}
                              </p>
                            </div>
                          </div>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Correct</p>
                            </div>
                            <div className={style.markDataRight}>
                              <p>{correctCount}</p>
                            </div>
                          </div>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Wrong</p>
                            </div>
                            <div className={style.markDataRight}>
                              <p>{incorrectCount}</p>
                            </div>
                          </div>
                          <div className={style.markData}>
                            <div className={style.markDataLeft}>
                              <p>Not answered</p>
                            </div>
                            <div className={style.markDataRight}>
                              <p>{skippedCount}</p>
                            </div>
                          </div>
                        </div>
                        <div className={style.FinishButton}>
                          <button
                            onClick={() => {
                              setFinishPopup(true);
                            }}
                          >
                            End Test
                          </button>
                        </div>
                        <div className={style.questionPaletteHeader}>
                          <p>Question Palette:</p>
                        </div>
                        <div className={style.questionPalette}>
                          {numbers.map((number, index) => {
                            const questionId = assessment[index]?.unique_id;
                            const status = assessmentData[questionId]?.status;

                            let backgroundColor;
                            if (currentIndex === index) {
                              backgroundColor = "#D9D9D9";
                            } else if (status === "correct") {
                              backgroundColor = "#00DFC7";
                            } else if (status === "incorrect") {
                              backgroundColor = "#FF7C8E";
                            } else if (status === "skipped") {
                              backgroundColor = "#818085";
                            } else {
                              backgroundColor = "#FFFFFF";
                            }

                            const numberStyle = {
                              backgroundColor,
                            };

                            return (
                              <div
                                onClick={() => {
                                  const uniqueId = currentAssessment?.unique_id;
                                  if (
                                    assessmentData[uniqueId]?.status ===
                                    "viewed"
                                  ) {
                                    setAssessmentData((prev) => ({
                                      ...prev,
                                      [uniqueId]: {
                                        ...prev[uniqueId],
                                        status: "skipped",
                                      },
                                    }));
                                    if (uniqueId && assessmentData[uniqueId]) {
                                      const currentAssmnt =
                                        assessment[currentIndex];
                                      let resetAnswers;
                                      let resetHighlightContent = "";
                                      let resetLastSelectedText = "";
                                      let resetAcrossClues = [];
                                      let resetDownClues = [];
                                      let highlightMultipleContent = "";
                                      let resetRightOrder = [];

                                      if (
                                        currentAssmnt.type ===
                                          "Match the following" ||
                                        currentAssmnt.type ===
                                          "Match the following with image"
                                      ) {
                                        const filteredLeft = (
                                          currentAssmnt.left || []
                                        ).filter(
                                          (leftData) => leftData.trim() !== ""
                                        );
                                        const filteredRight = (
                                          currentAssmnt.right || []
                                        ).filter(
                                          (rightData) => rightData.trim() !== ""
                                        );
                                        resetAnswers = {
                                          left: filteredLeft,
                                          right: filteredRight,
                                        };
                                        resetRightOrder = filteredRight.map(
                                          (_, i) => i
                                        );
                                      } else if (
                                        currentAssmnt.type === "Rearrange"
                                      ) {
                                        resetAnswers =
                                          currentAssmnt.options || [];
                                      } else if (
                                        currentAssmnt.type ===
                                        "cross word puzzle"
                                      ) {
                                        resetAnswers =
                                          currentAssmnt.options.map((row) =>
                                            row.map((cell) => ({
                                              clueID: cell.clueID || "",
                                              clueNumber: cell.clueNumber,
                                              cluevalue: "",
                                              disabled: cell.cluevalue === "",
                                            }))
                                          );

                                        resetAcrossClues =
                                          currentAssmnt.left.map((clueObj) => ({
                                            id: clueObj.id,
                                            number: clueObj.number,
                                            clue: clueObj.clue,
                                            answer: "",
                                          }));
                                        resetDownClues =
                                          currentAssmnt.right.map(
                                            (clueObj) => ({
                                              id: clueObj.id,
                                              number: clueObj.number,
                                              clue: clueObj.clue,
                                              answer: "",
                                            })
                                          );
                                      } else if (
                                        currentAssmnt.type === "highlight"
                                      ) {
                                        resetHighlightContent =
                                          currentAssmnt.options.replace(
                                            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                            "$1"
                                          ) || "";
                                        resetHighlightContent =
                                          resetHighlightContent.replace(
                                            /<span[^>]*>(.*?)<\/span>/g,
                                            "$1"
                                          ) || "";

                                        resetLastSelectedText = "";
                                      } else if (
                                        currentAssmnt.type ===
                                        "highlight_multiple"
                                      ) {
                                        highlightMultipleContent =
                                          currentAssmnt.options.replace(
                                            /(<[^>]+)style=["'][^"']*color:\s*rgb\(255,\s*122,\s*0\);?[^"']*["']/g,
                                            "$1"
                                          );

                                        highlightMultipleContent =
                                          highlightMultipleContent.replace(
                                            /<span[^>]*>(.*?)<\/span>/g,
                                            "$1"
                                          );
                                        resetAnswers = [];
                                      } else if (
                                        currentAssmnt.type === "Drag and Drop" ||
                                        currentAssmnt.type === "drag and drop_v2"
                                      ) {
                                        const updatedAnswer =
                                          currentAssmnt.answer.map((item) => {
                                            return {
                                              ...item,
                                              values: item.values.map(() => ""),
                                            };
                                          });
                                        resetAnswers = updatedAnswer;
                                      } else {
                                        resetAnswers = [];
                                      }

                                      setAssessmentData((prev) => ({
                                        ...prev,
                                        [uniqueId]: {
                                          ...prev[uniqueId],
                                          answers: resetAnswers,
                                          rightOrder: resetRightOrder,
                                          highlightContent:
                                            resetHighlightContent,
                                          lastSelectedText:
                                            resetLastSelectedText,
                                          cluesAcross: resetAcrossClues,
                                          cluesDown: resetDownClues,
                                          previousRange: null,
                                          highlightMultipleContent:
                                            highlightMultipleContent,
                                          highlightMultipleRange: [],
                                        },
                                      }));
                                      setSelectedOptions((prev) => {
                                        const { [uniqueId]: _, ...rest } = prev;
                                        return rest;
                                      });
                                    }
                                  }
                                  setCurrentIndex(number - 1);
                                  setValidateClicked(false);
                                  setSubmitLoading(false);
                                }}
                                key={number}
                                className={style.number}
                                style={numberStyle}
                              >
                                <p> {number}</p>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {trialUser && result ? (
                  <div className={style.bodyBottom}>
                    <div className={style.subscriptionHeader}>
                      <h4>You have successfully completed your trial!</h4>
                      <span>
                        Ready to take your English to the next level?{" "}
                      </span>
                      <p>Subscribe now and gain unlimited access to:</p>
                      <button
                        onClick={() => {
                          navigate("/subscribe", {
                            state: {
                              userID: userDetails && userDetails._id?.$oid,
                              Username: userDetails && userDetails.Username,
                              count: userDetails && userDetails.trail_count,
                              previousPath: "Summary",
                            },
                          });
                        }}
                      >
                        Subscribe Now
                      </button>
                    </div>
                    <div className={style.subscriptionGrid}>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={lessonImage} alt="Lesson" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Comprehensive Lessons:</p>
                          <span>
                            {" "}
                            Master every aspect of English with native designed
                            lessons.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={motivationImage} alt="Motivation" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Motivational Milestones:</p>
                          <span>
                            {" "}
                            Celebrate your progress and stay motivated with each
                            milestone.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          <div className={style.subscriptionCardImage}>
                            <img src={questionImage} alt="Question" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Assessment Questionnaires:</p>
                          <span>
                            {" "}
                            Measure your mastery and refine your skills through
                            targeted quizzes.
                          </span>
                        </div>
                      </div>
                      <div className={style.subscriptionCard}>
                        <div className={style.subscriptionCardImageContainer}>
                          {" "}
                          <div className={style.subscriptionCardImage}>
                            <img src={timeImage} alt="Time" />
                          </div>
                        </div>
                        <div className={style.subscriptionCardText}>
                          <p>Flexible Learning:</p>
                          <span>
                            Study anytime, anywhere, at your own pace.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={style.subscriptionBottom}>
                      <p>
                        Subscribe Today and <br />
                        Transform Your English Learning Journey!
                      </p>
                      <button
                        onClick={() => {
                          navigate("/subscribe", {
                            state: {
                              userID: userDetails && userDetails._id?.$oid,
                              Username: userDetails && userDetails.Username,
                            },
                          });
                        }}
                      >
                        Subscribe Now
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className={style.info}>
                <p>No Assessment found</p>
              </div>
            )}
          </>
        )}
      </div>

      {finishPopup ? (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupText}>
              <p>Are you sure you want to end the test?</p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={() => {
                  setFinishPopup(false);
                }}
              >
                No
              </button>
              <button
                className={style.yesButton}
                onClick={(e) => {
                  e.preventDefault();
                  endAssessment();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      {backButtonWarning ? (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            <div className={style.popupText}>
              <p>Your test will end if you go back. Are you sure you want to leave?</p>
            </div>
            <div className={style.PopupButton}>
              <button
                className={style.noButton}
                onClick={handleStayOnPage}
              >
                No
              </button>
              <button
                className={style.yesButton}
                onClick={handleLeavePage}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {/* {failedPopup && !result && (
        <div className={style.wrongAnswerPopup}>
          <div className={style.wrongAnswerPopupImage}>
            {" "}
            <img src={FailedImage} alt="Incorrect answer" />
            <div className={style.wrongAnswerPopupContent}>
              <p>
                Every mistake is an opportunity to learn and grow. <br />
                Keep going!
              </p>
            </div>
            <div className={style.wrongAnswerPopupClose}>
              <AiOutlineClose
                onClick={() => {
                  setFailedPopup(false);
                  setWrongAnswerCount(0);
                }}
              />
            </div>
          </div>
        </div>
      )} */}
      {achievementPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.achievementPopupSection}>
              <div className={style.achievementPopupHeder}>
                <h2>Hooray!</h2>
                <p>
                  You just achieved{" "}
                  <span>{carouselData.length} new badge</span>
                </p>
              </div>
              <div className={style.achievementCarousel}>
                <div
                  className={style.carouselTrackContainer}
                  style={{
                    overflowX: carouselData.length > 1 ? "auto" : "hidden",
                    display: "flex",
                    justifyContent:
                      carouselData.length === 1 ? "center" : "flex-start",
                  }}
                >
                  <div
                    className={style.carouselTrack}
                    style={{
                      transform: "none",
                    }}
                  >
                    {carouselData.map((item, index) => (
                      <div key={index} className={style.carouselSlide}>
                        <div className={style.achievementPopupImage}>
                          <img src={item.active_img} alt={item.name} />
                        </div>
                        <div className={style.carouselText}>
                          <h3>{item.name}</h3>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setAchievementPopup(false);
                  if (points > 0 || points > "0") {
                    setCollectPopup(true);
                  }
                }}
              >
                Collect
              </button>
            </div>
          </div>
        </>
      )}
      {collectPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.collectPopupHeader}>
              <p>Congratulations</p>
            </div>
            <div className={style.collectPopupImageContainer}>
              <div className={style.collectPopupImage}>
                <img src={Coins} alt="Reward" />
              </div>
              <div className={style.collectPopupLottie}>
                <Lottie
                  animationData={coinsLottie}
                  loop={true}
                  duration
                  autoplay
                />
              </div>
            </div>
            <div className={style.collectPopupText}>
              <span>You receive</span>
              <h3>{points} xp</h3>
              {/* <p>500 xp for completing a module within 6 weeks</p>
            <p>100 xp for scoring above 85%</p> */}
            </div>
            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setCollectPopup(false);
                  const token = userDetails && userDetails.auth_token; // Assuming `key` is the token
                  dispatch(
                    fetchUserDetails({
                      userid: userDetails && userDetails._id?.$oid,
                      token,
                    })
                  );
                }}
              >
                Collect All
              </button>
            </div>
            <div className={style.xpContainer}>
              <p
                className={style.xpLink}
                onClick={(e) => {
                  e.stopPropagation(); 
                  setShowXpInfo(!showXpInfo);
                }}
              >
                What is Xp?
              </p>                      
              {showXpInfo && (
                <div className={style.xpTooltip}>
                  XP (Experience Points) are rewards you earn by scoring well in tests.
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {showPopupMsg && popupMsg && (
        <div className={style.popupOverlay}>
          <div className={style.achievementPopup}>
            <p className={style.PopupTextMsg}>{popupMsg}</p>
            <div className={style.collectPopupImageContainer}>
              <div className={style.collectPopupImageLoss}>
                <img src={Coins} alt="Reward" />
              </div>
              <div className={style.collectPopupLottie}>
                <Lottie
                  animationData={coinsLottie}
                  loop={true}
                  duration
                  autoplay
                />
              </div>
            </div>
            <div className={style.popupDesc}>
            {points > 0 ? (
              <>
                <h4>
                  You earned extra <br />
               {points} xp
                </h4>
              </>
            ) : (
              <>
                <p>Oops! Your average Topic Test score has dropped a level!</p>
                <span>
                  Not to worry, revisit the Module and Skills Practice sections then try again for a higher score.
                </span>
                <span>Good luck!</span>
              </>
            )}
            </div>
            <div className={style.achievementPopupButton}>
              <button
              onClick={() => {
                setShowPopupMsg(false);
                const token = userDetails && userDetails.auth_token; 
                  dispatch(
                    fetchUserDetails({
                      userid: userDetails && userDetails._id?.$oid,
                      token,
                    })
                  );
              }
              }
            >
              Got it
            </button>
            </div>
          </div>
        </div>
      )}
      
      {coinsAnimation && !showPopupMsg && (
         <>
          <div className={style.popupOverlay}></div>
          <div className={style.achievementPopup}>
            <div className={style.collectPopupHeader}>
              <p>Congratulations</p>
            </div>
            <div className={style.collectPopupImageContainer}>
              <div className={style.collectPopupImage}>
                <img src={Coins} alt="Reward" />
              </div>
              <div className={style.collectPopupLottie}>
                <Lottie
                  animationData={coinsLottie}
                  loop={true}
                  duration
                  autoplay
                />
              </div>
            </div>
            <div className={style.collectPopupText}>
              <span>You receive</span>
              <h3>{points} xp</h3>
            </div>
            <div className={style.achievementPopupButton}>
              <button
                onClick={() => {
                  setCoinsAnimation(false);
                  const token = userDetails && userDetails.auth_token; 
                  dispatch(
                    fetchUserDetails({
                      userid: userDetails && userDetails._id?.$oid,
                      token,
                    })
                  );
                }}
              >
                Collect All
              </button>
            </div>
          </div>
        </>
      )
      }
    </div>
  );
};

export default Assessment;
